
import _ from 'lodash'
import * as Yup from 'yup'
import moment from 'moment'
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Field, Formik, Form, ErrorMessage, useFormikContext } from 'formik'
import DateFnsUtils from '@date-io/date-fns'
import { Box, Typography, TextField, MenuItem, Tooltip, FormControlLabel, Switch, Divider, Button, Grid, Checkbox, FormControl, FormGroup, Select } from '@material-ui/core'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import ClearIcon from '@material-ui/icons/Clear'
import { accountService } from '../../Services/AccountService/AccountService'
import { programService, utilityService } from '../../Services'
import Icon from '../../utils/icons'
import { AppButton, Loader, Breadcrumb, DisplayMessage } from '../../Components'
import { Cards, Toggle } from '../../elements'
import { ERROR, SUCCESS } from '../../utils/messageTypes'
import { SOMETHING_WENT_WRONG } from '../../Constants/MessagesConstant'
import { adminProgramForm, superAdminProgramForm, incentiveStructureOptions, CsipConfigOptions, PROFILE_LIST, csipConfiguration, getUtilites, featureInCreation, validationLabel, programSettingsLabel, getProgramSettingsToggleOptions, AUTONOMOUS, DEFAULT, batteryEventSubTypes, hpEventSubTypes, evseEventSubTypes, hvacEventSubTypes, PRE_APPROVED_AUTH, CLOUD_API, LOCAL_API, OWNER, HOST } from './constant'
import { useStyles } from './style'
import { getProgramById } from '../../AppRedux/actions/Programs'
import Error404 from '../ErrorPages/Error404'
import { RadioButtonChecked, RadioButtonUnchecked, CheckBoxOutlineBlank, CheckBox } from '@material-ui/icons'
import { getProgramDetailsEventFlagValue } from './utils'
import { pushToDataLayer, USERBEHAVIOURTRACKING } from '../../utils/gaEnvironment'
import UploadFile from '../../Components/UploadFile'
import programDetailsCsvFile from '../../Assets/Images/programDetailsCsvFile.svg'
import termsAndConditionsFile from '../../Assets/Images/termsAndConditionsFile.svg'
import DashboardWidgets from './DashboardWidgets'
import download from '../../Assets/Images/download.svg'
import DownloadFile from '../../utils/downloadFile'
import { utilService } from '../../Services/UtilService/UtilService'

const ALL = 'ALL'
const marginLeft = 0.625
function CreatePrograms(props) {
  const classes = useStyles()
  const [openToastMessage, setOpen] = useState(false)
  const [form, setForm] = useState([])
  const [loading, setLoading] = useState(false)
  const [accountLoading, setAccountLoading] = useState(false)
  const [utilityOptions, setUtilityOptions] = useState([])
  const [messageType, setMessageType] = useState('')
  const [message, setMessage] = useState('')
  const [isEdit, setProgramEdit] = useState(false)
  const [payload, setPayload] = useState('')
  const [accountDetails, setAccountDetails] = useState({})
  const [allAccounts, setAllAccounts] = useState([])
  const [utilityList, setUtilityList] = useState([])
  const [showCheckbox, setShowCheckbox] = useState(false)
  const [selectedToggle, setToggleValue] = useState(programSettingsLabel.PROGRAM_INFORMATION)
  const [countries, setCountries] = useState({})
  const [states, setStates] = useState(props.stateList)
  const [selectedCountry, setSelectedCountry] = useState(props.programDetails?.country)
  const [maxEventDurationProgramValue, setmaxEventDurationProgramValue] = useState()
  const [maxEventDurationDefaultValue, setmaxEventDurationDefaultValue] = useState()
  const [maxEventDurationRecurringValue, setmaxEventDurationRecurringValue] = useState()
  const [minEventDurationProgramValue, setminEventDurationProgramValue] = useState()
  const [minEventDurationDefaultValue, setminEventDurationDefaultValue] = useState()
  const [minEventDurationRecurringValue, setminEventDurationRecurringValue] = useState()
  const [helperText, setHelperText] = useState('')
  const [functions, setFunctions] = useState(_.get(props.programDetails, 'feature_flags.functions', []))
  const [isOcpp, setIsOcpp] = useState(false)
  const [csipConfigDetails, setCsipConfigDetails] = useState();

  const isAutonomous = (isEdit && props.programDetails?.feature_flags?.event_feature_config?.AUTONOMOUS !== undefined) ? true : false

  const handleToggleChange = (value) => {
    setToggleValue(value)
  }

  useEffect(() => {
    const id = _.get(props.match.params, 'programId', '')
    setProgramEdit(id ? true : false)

    if (props.accountId && id && id !== props.programId) {
      props.getProgramById({
        accountId: props.accountId,
        programId: id
      })
    }
  }, [props, props.match.params])

  useEffect(() => {
    setmaxEventDurationProgramValue(props.programDetails?.feature_flags?.max_event_duration / 1000)
    setmaxEventDurationDefaultValue(props.programDetails?.feature_flags?.event_feature_config?.DEFAULT?.max_event_duration / 1000)
    setmaxEventDurationRecurringValue(props.programDetails?.feature_flags?.event_feature_config?.AUTONOMOUS?.max_event_duration / 1000)
    setminEventDurationProgramValue(props.programDetails?.feature_flags?.min_event_duration / 1000)
    setminEventDurationDefaultValue(props.programDetails?.feature_flags?.event_feature_config?.DEFAULT?.min_event_duration / 1000)
    setminEventDurationRecurringValue(props.programDetails?.feature_flags?.event_feature_config?.AUTONOMOUS?.min_event_duration / 1000)
    if (props.programDetails?.feature_flags?.functions) {
      setFunctions(props.programDetails.feature_flags.functions)
    }
    if (props.programDetails?.feature_flags?.evse_control_type) {
      if (props.programDetails.feature_flags.evse_control_type === 'OCPP') {
        setIsOcpp(true)
      }
    }
  }, [props.programDetails])

  const errorCb = (error) => {
    const data = _.get(error, 'data', {})
    const errorDetail = _.get(data, 'error', {})
    const additionalInfo = _.get(errorDetail, 'displayMessage', '')

    setOpen(true)
    setMessageType(ERROR)
    setMessage(additionalInfo ? `${additionalInfo}` : SOMETHING_WENT_WRONG)
    setLoading(false)
  }

  useEffect(() => {
    if (props.programDetails.country) {
      getAllStates(props.programDetails.country)
    }
  }, [props.programDetails.country])

  useEffect(() => {
    if (_.isEmpty(countries))
      getAllCountries()
  }, [])

  useEffect(() => {
    if(isEdit && props.isSuperAdmin){
      setLoading(true)
      programService.getCsipConfigurationDetails(props.accountId)
        .then((response) => {
          setCsipConfigDetails(response)
          setLoading(false)
        })
        .catch(() => {
          setForm(superAdminProgramForm())
        })
    }
  }, [isEdit, props.isSuperAdmin])

  useEffect(() => {
    const obj = {
      stateList: states,
      countryList: countries,
      utilityList: utilityList,
      accountList: allAccounts
    }

    const id = _.get(props.match.params, 'programId', '')
    const isEdit = id ? true : false
    if ((!isEdit && !_.isEmpty(countries)) || (props.programDetails.country && !_.isEmpty(states) && !_.isEmpty(countries))) {
      if (props.accountId) {
        if (selectedCountry || props.programDetails.country) {
          setLoading(true)
          utilityService.getAllUtilityByCountry(props.accountId, selectedCountry || props.programDetails.country)
            .then((response) => {
              obj.utilityList = response || []
              setUtilityList(response || [])
              setUtilityOptions(getUtilites(_.get(obj, 'utilityList', [])))
              if (props.isSuperAdmin) {
                setForm(superAdminProgramForm(obj, isEdit))
              } else {
                setForm(adminProgramForm(obj))
              }
              setLoading(false)
            })
            .catch(() => {
              setForm(superAdminProgramForm(obj, isEdit))
              errorCb()
            })
        }
        if (props.isSuperAdmin && _.isEmpty(allAccounts)) {
          setAccountLoading(true)
          accountService.getAllAccounts(props.accountId)
            .then((userRsponse) => {
              obj.accountList = userRsponse || []
              setAllAccounts(userRsponse || [])
              setForm(superAdminProgramForm(obj, isEdit))
              setAccountLoading(false)
            })
            .catch(() => {
              setForm(superAdminProgramForm(obj, isEdit))
              setAccountLoading(false)
              errorCb()
            })
        }
      }
      if (props.isAdmin && !props.isSuperAdmin) {
        accountService.getAccountDetails({ account_id: props.accountId })
          .then(accountData => {
            setAccountDetails(accountData.account)
            if (!isEdit)
              setForm(adminProgramForm(obj))
          })
          .catch(error => {
            if (!isEdit)
              setForm(adminProgramForm(obj))
            errorCb(error)
          })
      }
    }
  }, [props.accountId, props.isSuperAdmin, states, countries, props.programDetails.country])

  const getAllStates = (country, setFieldValue) => {
    setLoading(true)
    utilService.getStateByCountry(country)
      .then(stateData => {
        if (_.isEmpty(stateData)) {
          setStates({ ALL: ALL })
          if (setFieldValue) {
            setFieldValue('location', ALL)
          }
        } else {
          setStates({ ...stateData, ALL: ALL })
          if (setFieldValue) {
            setFieldValue('location', '')
          }
        }
      })
      .catch(error => {
        errorCb(error)
      })
  }

  const getAllCountries = () => {
    setLoading(true)
    utilService.getAllCountries()
      .then(countriesData => {
        setCountries(countriesData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
      })
  }

  const downloadTemplate = (type) => {
    setLoading(true)
    if (type === 'programDetail') {
      programService.downloadProgramDetailTemplate(props.accountId)
        .then(templateData => {
          DownloadFile(templateData)
          setOpen(true)
          setMessage('Template downloaded successfully')
          setMessageType(SUCCESS)
          setLoading(false)
        })
        .catch(error => {
          errorCb(error)
        })
    } else if (type === 'applicationCSV') {
      programService.downloadApplicationCSVTemplate(props.accountId)
        .then(templateData => {
          DownloadFile(templateData)
          setOpen(true)
          setMessage('Template downloaded successfully')
          setMessageType(SUCCESS)
          setLoading(false)
        })
        .catch(error => {
          errorCb(error)
        })
    } else {
      setLoading(false)
    }
  }

  const downloadRecentlyUploadedFile = (type) => {
    setLoading(true)
    if (type === 'programDetail') {
      programService.downloadRecentlyUploadedProgramDetailsCSV(props.accountId, props.programId)
        .then(templateData => {
          DownloadFile(templateData)
          setOpen(true)
          setMessage('File downloaded successfully')
          setMessageType(SUCCESS)
          setLoading(false)
        })
        .catch(error => {
          errorCb(error)
        })
    } else if (type === 'applicationCSV') {
      programService.downloadRecentlyUploadedApplicationsCSV(props.accountId, props.programId)
        .then(templateData => {
          DownloadFile(templateData)
          setOpen(true)
          setMessage('File downloaded successfully')
          setMessageType(SUCCESS)
          setLoading(false)
        })
        .catch(error => {
          errorCb(error)
        })
    } else {
      setLoading(false)
    }
  }

  const handleValueChange = (input, value) => {
    switch (input) {
      case 'maxEventDurationProgram':
        setmaxEventDurationProgramValue(value)
        break
      case 'maxEventDurationDefault':
        setmaxEventDurationDefaultValue(value)
        break
      case 'maxEventDurationRecurring':
        setmaxEventDurationRecurringValue(value)
        break
      case 'minEventDurationProgram':
        setminEventDurationProgramValue(value)
        break
      case 'minEventDurationDefault':
        setminEventDurationDefaultValue(value)
        break
      default:
        setminEventDurationRecurringValue(value)
        break
    }
  }

  useEffect(() => {
    if (maxEventDurationProgramValue !== '' && (Number(minEventDurationProgramValue) > Number(maxEventDurationProgramValue) || Number(maxEventDurationProgramValue) > 86400)) {
      setHelperText('Max Event Duration at Program level must be greater than or equal to Min Event Duration and less than 86400')
    } else if (maxEventDurationDefaultValue !== '' && (Number(minEventDurationDefaultValue) > Number(maxEventDurationDefaultValue) || Number(maxEventDurationDefaultValue) > 86400)) {
      setHelperText('Max Event Duration at One-Time level must be greater than or equal to Min Event Duration and less than 86400')
    } else if (maxEventDurationRecurringValue !== '' && (isAutonomous && (Number(minEventDurationRecurringValue) > Number(maxEventDurationRecurringValue) || maxEventDurationRecurringValue > 86400))) {
      setHelperText('Max Event Duration at Recurring level must be greater than or equal to Min Event Duration and less than 86400')
    } else if (minEventDurationProgramValue !== '' && (Number(minEventDurationProgramValue) < 60 || Number(minEventDurationProgramValue) > 900)) {
      setHelperText(`Min Event Duration at Program level must be greater than or equal to 60 and less than or equal to minimum of 900 and max event duration`)
    } else if (minEventDurationDefaultValue !== '' && (Number(minEventDurationDefaultValue) < 60 || Number(minEventDurationDefaultValue) > 900)) {
      setHelperText(`Min Event Duration at One-Time level must be greater than or equal to 60 and less than or equal to minimum of 900 and max event duration`)
    } else if (minEventDurationRecurringValue !== '' && (Number(minEventDurationRecurringValue) < 60 || Number(minEventDurationRecurringValue) > 900)) {
      setHelperText(`Min Event Duration at Recurring level must be greater than or equal to 60 and less than or equal to minimum of 900 and max event duration`)
    } else {
      setHelperText('')
    }
  }, [minEventDurationProgramValue, maxEventDurationProgramValue, minEventDurationDefaultValue, maxEventDurationDefaultValue, minEventDurationRecurringValue, maxEventDurationRecurringValue])

  const adminSchema = Yup.object({
    name: Yup.string().required('This field is required'),
    location: Yup.string().required('This field is required'),
    utilityName: Yup.string().required('This field is required'),
    incentiveStructure: Yup.string().required('This field is required'),
    incentiveValue: Yup.string().required('This field is required'),
    maxEnrollment: Yup.string().min(1, 'Max enrollment must be min 1 character').max(9, 'Max enrollment must be max 9 characters'),
  })

  const superAdminSchema = Yup.object({
    name: Yup.string().required('This field is required'),
    location: Yup.string().required('This field is required'),
    account: Yup.string().required('This field is required'),
    utilityName: Yup.string().required('This field is required'),
    incentiveStructure: Yup.string().required('This field is required'),
    incentiveValue: Yup.string().required('This field is required'),
    maxEnrollment: Yup.string().min(1, 'Max enrollment must be min 1 character').max(9, 'Max enrollment must be max 9 characters'),
    minimumRateWatt: Yup.number().when([], (schema) => {
      if (flagInProgram('minimum_rate_watt_percent') && isEdit) {
        return schema.min(0, 'Minimum Rate Watt must be greater than or equal to 0')
          .max(100, 'Minimum Rate Watt must be less than or equal to 100')
          .integer('Minimum Rate Watt must be a whole number')
      }
      return schema
    }),
    retryTimeInterval: Yup.number().when([], (schema) => {
      if (flagInProgram('command_retry_time_interval_post_start') && isEdit) {
        return schema.min(0, 'Command Retry Time Interval must be greater than or equal to 0')
          .max(900, 'Command Retry Time Interval must be less than or equal to 900')
          .integer('Command Retry Time Interval must be a whole number')
      }
      return schema
    }),
    liveStreamTelemetryFrequency: Yup.number().when([], (schema) => {
      if (flagInProgram('live_stream_telemetry_frequency') && isEdit) {
        return schema.required('Live Stream Telemetry Frequency must be greater than or equal to 0')
      }
    }),
    eventLeadTime: Yup.number().when([], (schema) => {
      if (flagInProgram('event_lead_time') && isEdit) {
        return schema.min(0, 'Event Lead Time must be greater than or equal to 0')
          .max(900, 'Event Lead Time must be less than or equal to 900')
          .integer('Event Lead Time must be a whole number')
      }
      return schema
    }),
    pcuBinWidth: Yup.number().when([], (schema) => {
      if (flagInProgram('pcu_bin_width') && isEdit) {
        return schema.min(0, 'Pcu Bin Width must be greater than or equal to 0')
          .max(900, 'Pcu Bin Width must be less than or equal to 900')
          .integer('Pcu Bin Width must be a whole number')
      }
      return schema
    }),
    pcuPollingInterval: Yup.number().when([], (schema) => {
      if (flagInProgram('pcu_polling_interval') && isEdit) {
        return schema.min(0, 'Pcu Polling Interval must be greater than or equal to 0')
          .max(900, 'Pcu Polling Interval must be less than or equal to 900')
          .integer('Pcu Polling Interval must be a whole number')
      }
      return schema
    }),
    rgmBinWidth: Yup.number().when([], (schema) => {
      if (flagInProgram('rgm_bin_width') && isEdit) {
        return schema.min(0, 'Rgm Bin Width must be greater than or equal to 0')
          .max(900, 'Rgm Bin Width must be less than or equal to 900')
          .integer('Rgm Bin Width must be a whole number')
      }
      return schema
    }),
    rgmPollingInterval: Yup.number().when([], (schema) => {
      if (flagInProgram('rgm_polling_interval') && isEdit) {
        return schema.min(0, 'Rgm Polling Interval must be greater than or equal to 0')
          .max(900, 'Rgm Polling Interval must be less than or equal to 900')
          .integer('Rgm Polling Interval must be a whole number')
      }
      return schema
    }),
    reportingIntervalPeriod: Yup.number().when([], (schema) => {
      if (flagInProgram('reporting_interval_period') && isEdit) {
        return schema.min(0, 'Reporting Interval Period must be greater than or equal to 0')
          .max(900, 'Reporting Interval Period must be less than or equal to 900')
          .integer('Reporting Interval Period must be a whole number')
      }
      return schema
    }),
    batteryLockConfig: Yup.number().min(1, 'Battery Full-Backup mode Prior Hours must be greater than 0'),
    functions: Yup.array().min(1, 'Function is required'),
    controlType: Yup.array().min(1, 'Control Type is required'),
    systemAccessList: Yup.array().min(1, 'System access authorization is required'),
    minSiteStage: Yup.number().min(0, 'Minimum Allowed Site Stage cannot be less than 0').max(5, 'Minimum Allowed Site Stage cannot be greater than 5')
  })

  const renderLabel = (values) => {
    const incentiveStructureValue = _.get(values, 'incentiveStructure', '')
    const newLabel = incentiveStructureOptions[incentiveStructureValue]

    return _.get(newLabel, 'header', '')
  }

  const renderInfoContent = () => (
    <Typography className={classes.infoText}>The program start date will be the date on which the program is approved.</Typography>
  )

  const renderDurationLabel = () => {
    return (
      <Box className={classes.labelWrapper}>
        <Typography className={classes.programEndDate}>Program End Date (Optional)</Typography>
        <Tooltip
          title={renderInfoContent()}
          className={classes.infoIcon}
          placement="right-end"
          classes={{ tooltip: classes.infoWrapper }}
        >
          <InfoOutlinedIcon />
        </Tooltip>
      </Box>
    )
  }

  const navToPrograms = (isEdit, response) => {
    if (isEdit) {
      props.history.replace({
        pathname: `/program-details/${props.programId}`,
        showMessage: true,
        message: 'Program updated successfully',
        messageType: SUCCESS
      })
    } else {
      props.history.replace({
        pathname: '/programs',
        showMessage: true,
        message: 'Successfully created a new program',
        messageType: SUCCESS
      })
    }
  }

  const handleBack = () => {
    if (isEdit) {
      props.history.replace({
        pathname: `/program-details/${props.programId}`
      })
    } else {
      props.history.push(props.isSuperAdmin ? '/admin' : '/programs')
    }
  }

  const renderIcon = (errors, touched, id) => {
    if (!_.isEmpty(touched) && id !== 'adminName') {
      return touched[id] ? _.isUndefined(errors[id]) ? <Icon src="circleTick" /> : <Icon src="circleCross" /> : <></>
    }
    return <></>
  }

  const renderNavValue = () => {
    if (isEdit) {
      const obj = []
      obj[`${props.programDetails['program_name_admin_ui']}`] = `/programs/${props.programId}`
      obj.state = {
        program: {
          program_object: props.programDetails || {}
        }
      }
      const nav = [{ 'Home': '/' }, { 'Programs': '/programs' }, obj, { 'Program Details': `/program-details/${props.programId}`, 'state': { program: props.programDetails || {} } }, { 'Edit Program': '' }]

      return nav
    } else if (props.isSuperAdmin) {
      return [{ 'Home': '/' }, { 'Admin': '/admin' }, { 'Create a New Program': '' }]
    } else {
      return [{ 'Home': '/' }, { 'Programs': '/programs' }, { 'Create a New Program': '' }]
    }
  }

  const renderUniqueName = (obj) => {
    let uniqueVal = ''

    if (obj.name) {
      uniqueVal = (obj.name).split(' ').join('_')
    }

    if (obj.utilityName && !_.isEmpty(utilityOptions)) {
      let selectedUtility = utilityOptions.find(list => list.value === obj.utilityName)
      selectedUtility = selectedUtility ? selectedUtility.label : ''
      const utilName = (selectedUtility).split(' ').join('_')
      uniqueVal = uniqueVal ? `${uniqueVal}_${utilName}` : utilName
    }

    if (obj.location && obj.location !== ALL) {
      uniqueVal = uniqueVal ? `${uniqueVal}_${obj.location}` : obj.location
    }

    return uniqueVal
  }

  const autoValidation = [

    {
      type: "SYSTEM_OWNER",
      enabled: false,
      values: [],
    },
    {
      type: "PV_INSTALLER",
      enabled: false,
      values: [],
    },
    {
      type: "PV_SYSTEM_MAINTAINER",
      enabled: false,
      values: [],
    },
    {
      type: "PRE_APPROVED_AUTH",
      enabled: false,
      values: [],
    },
    {
      type: "HO_ACCESS_TOKEN",
      enabled: false,
      values: null,
      noTextField: true
    }
  ]

  const defaultEventSubTypes = [
    { name: 'Charge_From_PV', max_target_soc: 100, min_target_soc: 10 },
    { name: 'Charge_From_NetPV', max_target_soc: 100, min_target_soc: 10 },
    { name: 'Charge_From_PV_Grid', max_target_soc: 100, min_target_soc: 10 },
    { name: 'Discharge_To_Load', max_target_soc: 100, min_target_soc: 10 },
    { name: 'Discharge_To_NetLoad', max_target_soc: 100, min_target_soc: 10 },
    { name: 'Discharge_To_Load_Grid', max_target_soc: 100, min_target_soc: 10 },
    { name: 'Idle', max_target_soc: 100, min_target_soc: 100 }
  ]

  const defaultEventTypes = ['BATTERY_CHARGE', 'BATTERY_DISCHARGE', 'IDLE']

  const handleString = (str, type) => {
    if (type === 'allowedSites') {
      return typeof str === 'string' ? str.trim() !== '' ?
        str.split(/\s*,\s*/).filter(item => item.trim() !== '').map(Number).filter(n => !isNaN(n))
        : [] : str
    } else {
      return typeof str === 'string' ? str.trim() !== '' ? str.split(/\s*,\s*/).filter(Boolean) : [] : str
    }
  }

  const flagInProgram = (flag, parameter) => {
    if (parameter !== null && (parameter === DEFAULT || parameter === AUTONOMOUS) && props.programDetails && props.programDetails?.feature_flags) {
      const featureConfig = props.programDetails?.feature_flags?.event_feature_config
      return featureConfig && parameter in featureConfig && flag in featureConfig[parameter]
    } else if (props.programDetails?.feature_flags) {
      return flag in props.programDetails.feature_flags
    }
    return false
  }

  const initialValues = () => {
    let incentiveStructure = _.get(incentiveStructureOptions.UPFRONT_DISCOUNT, 'value', '')
    let incentiveValue = ''

    if (isEdit || payload) {
      const obj = payload ? _.get(payload, 'incentive_structure', {}) : _.get(props.programDetails, 'incentive_structure', {})
      const key = Object.keys(obj)

      incentiveStructure = _.isEmpty(key) ? incentiveStructure : _.first(key)
      incentiveValue = obj[incentiveStructure] || ''
    }
    const initalVal = {
      name: payload ? _.get(payload, 'name', '') : isEdit ? _.get(props.programDetails, 'name', '') : '',
      country: payload ? _.get(payload, 'country', '') : isEdit ? _.get(props.programDetails, 'country', '') : '',
      location: payload ? _.get(payload, 'state', '') : isEdit ? _.get(props.programDetails, 'state', '') : '',
      utilityName: payload ? _.get(payload, 'util_id', '') : isEdit ? _.get(props.programDetails, 'util_id', '') : '',
      maxEnrollment: payload && payload.max_system_enrollments < 999999999 ? _.get(payload, 'max_system_enrollments', '') : isEdit ? _.get(props.programDetails, 'max_system_enrollments', '') : '',
      enrollmentWebLink: payload ? _.get(payload, 'enrollment_web_link', '') : isEdit ? _.get(props.programDetails, 'enrollment_web_link', '') : '',
      duration: payload ? _.get(payload, 'program_end_date', null) : isEdit ? _.get(props.programDetails, 'program_end_date', null) : null,
      incentiveStructure,
      incentiveValue,
      account: payload ? _.get(payload, 'account_id', '') : isEdit ? _.get(props.programDetails, 'account_id', '') : '',
      adminName: payload ? _.get(payload, 'program_name_admin_ui', '') : isEdit ? _.get(props.programDetails, 'program_name_admin_ui', '') : '',
      cancelEventProgram: payload ? _.get(payload, 'feature_flags.event_cancellation_allowed_for_upcoming_events', true) : isEdit ? _.get(props.programDetails, 'feature_flags.event_cancellation_allowed_for_upcoming_events', true) : true,
      stopEventProgram: payload ? _.get(payload, 'feature_flags.event_ending_allowed_for_ongoing_event', true) : isEdit ? _.get(props.programDetails, 'feature_flags.event_ending_allowed_for_ongoing_event', true) : true,
      eventOptProgram: payload ? _.get(payload, 'feature_flags.event_opt_in_opt_out_capability', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_opt_in_opt_out_capability', false) : false,
      targetSocOverrideProgram: payload ? _.get(payload, 'feature_flags.target_soc_override', false) : isEdit ? _.get(props.programDetails, 'feature_flags.target_soc_override', false) : '',
      scheduledPowerOverrideProgram: payload ? _.get(payload, 'feature_flags.scheduled_power_override', false) : isEdit ? _.get(props.programDetails, 'feature_flags.scheduled_power_override', false) : '',
      maxEventDurationProgram: payload ? _.get(payload, 'feature_flags.max_event_duration', '') / 1000 : isEdit ? _.get(props.programDetails, 'feature_flags.max_event_duration', '') / 1000 : '',
      minEventDurationProgram: payload ? _.get(payload, 'feature_flags.min_event_duration', '') / 1000 : isEdit ? _.get(props.programDetails, 'feature_flags.min_event_duration', '') / 1000 : '',
      stormGuardOverrideProgram: payload ? _.get(payload, 'feature_flags.storm_guard_override', false) : isEdit ? _.get(props.programDetails, 'feature_flags.storm_guard_override', false) : false,
      cancelEventDefault: payload ? _.get(payload, 'feature_flags.event_feature_config.DEFAULT.event_cancellation_allowed_for_upcoming_events', true) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.DEFAULT.event_cancellation_allowed_for_upcoming_events', true) : true,
      eventOptDefault: payload ? _.get(payload, 'feature_flags.event_feature_config.DEFAULT.event_opt_in_opt_out_capability', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.DEFAULT.event_opt_in_opt_out_capability', false) : false,
      targetSocOverrideDefault: payload ? _.get(payload, 'feature_flags.event_feature_config.DEFAULT.target_soc_override', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.DEFAULT.target_soc_override', false) : '',
      scheduledPowerOverrideDefault: payload ? _.get(payload, 'feature_flags.event_feature_config.DEFAULT.scheduled_power_override', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.DEFAULT.scheduled_power_override', false) : '',
      stopEventDefault: payload ? _.get(payload, 'feature_flags.event_feature_config.DEFAULT.event_ending_allowed_for_ongoing_event', true) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.DEFAULT.event_ending_allowed_for_ongoing_event', true) : true,
      maxEventDurationDefault: payload ? _.get(payload, 'feature_flags.event_feature_config.DEFAULT.max_event_duration', '') / 1000 : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.DEFAULT.max_event_duration', '') / 1000 : '',
      minEventDurationDefault: payload ? _.get(payload, 'feature_flags.event_feature_config.DEFAULT.min_event_duration', '') / 1000 : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.DEFAULT.min_event_duration', '') / 1000 : '',
      stormGuardOverrideDefault: payload ? _.get(payload, 'feature_flags.event_feature_config.DEFAULT.storm_guard_override', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.DEFAULT.storm_guard_override', false) : false,
      scheduledPowerOverrideRecurring: payload ? _.get(payload, 'feature_flags.event_feature_config.AUTONOMOUS.scheduled_power_override', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.AUTONOMOUS.scheduled_power_override', false) : '',
      maxEventDurationRecurring: payload ? _.get(payload, 'feature_flags.event_feature_config.AUTONOMOUS.max_event_duration', '') / 1000 : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.AUTONOMOUS.max_event_duration', '') / 1000 : '',
      minEventDurationRecurring: payload ? _.get(payload, 'feature_flags.event_feature_config.AUTONOMOUS.min_event_duration', '') / 1000 : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.AUTONOMOUS.min_event_duration', '') / 1000 : '',
      targetSocOverrideRecurring: payload ? _.get(payload, 'feature_flags.event_feature_config.AUTONOMOUS.target_soc_override', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.AUTONOMOUS.target_soc_override', false) : '',
      eventOptRecurring: payload ? _.get(payload, 'feature_flags.event_feature_config.AUTONOMOUS.event_opt_in_opt_out_capability', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.AUTONOMOUS.event_opt_in_opt_out_capability', false) : '',
      cancelEventRecurring: payload ? _.get(payload, 'feature_flags.event_feature_config.AUTONOMOUS.event_cancellation_allowed_for_upcoming_events', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.AUTONOMOUS.event_cancellation_allowed_for_upcoming_events', false) : '',
      stopEventRecurring: payload ? _.get(payload, 'feature_flags.event_feature_config.AUTONOMOUS.event_ending_allowed_for_ongoing_event', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.AUTONOMOUS.event_ending_allowed_for_ongoing_event', false) : '',
      stormGuardOverrideRecurring: payload ? _.get(payload, 'feature_flags.event_feature_config.AUTONOMOUS.storm_guard_override', false) : isEdit ? _.get(props.programDetails, 'feature_flags.event_feature_config.AUTONOMOUS.storm_guard_override', false) : false,
      siteGrid: payload ? _.get(payload, 'feature_flags.site_on_grid_off_grid_feature', false) : isEdit ? getProgramDetailsEventFlagValue(props.programDetails, 'site_on_grid_off_grid_feature', true) : '',
      programAndEvent: payload ? _.get(payload, 'feature_flags.program_and_events', false) : isEdit ? _.get(props.programDetails, 'feature_flags.program_and_events', false) : '',
      systemReports: payload ? _.get(payload, 'feature_flags.system_reports', false) : isEdit ? _.get(props.programDetails, 'feature_flags.system_reports', false) : '',
      forecastingReports: payload ? _.get(payload, 'feature_flags.forecasting_reports', false) : isEdit ? _.get(props.programDetails, 'feature_flags.forecasting_reports', false) : '',
      userReports: payload ? _.get(payload, 'feature_flags.user_reports', false) : isEdit ? _.get(props.programDetails, 'feature_flags.user_reports', false) : '',
      loadBuildUp: payload ? _.get(payload, 'feature_flags.load_build_up_event_type', false) : isEdit ? _.get(props.programDetails, 'feature_flags.load_build_up_event_type', false) : '',
      loadReduction: payload ? _.get(payload, 'feature_flags.load_reduction_event_type', false) : isEdit ? _.get(props.programDetails, 'feature_flags.load_reduction_event_type', false) : '',
      enrolmentOptions: payload ? _.get(payload, 'feature_flags.system_enrollment_option', 'NONE') : isEdit ? _.get(props.programDetails, 'feature_flags.system_enrollment_option', 'NONE') : 'NONE',
      systemAccessList: payload ? _.get(payload, 'feature_flags.system_access_list', '') : isEdit ? _.get(props.programDetails, 'feature_flags.system_access_list', '') : '',
      signatureTAndC: payload ? _.get(payload, 'feature_flags.input_fields_terms_and_conditions_signatures', false) : isEdit ? _.get(props.programDetails, 'feature_flags.input_fields_terms_and_conditions_signatures', false) : '',
      committedEnergy: payload ? _.get(payload, 'feature_flags.committed_energy_in_program', false) : isEdit ? _.get(props.programDetails, 'feature_flags.committed_energy_in_program', false) : '',
      committedPower: payload ? _.get(payload, 'feature_flags.committed_power_in_program', false) : isEdit ? _.get(props.programDetails, 'feature_flags.committed_power_in_program', false) : '',
      reserveSoc: payload ? _.get(payload, 'feature_flags.battery_reserve_soc_configurability', false) : isEdit ? _.get(props.programDetails, 'feature_flags.battery_reserve_soc_configurability', false) : '',
      externalSteeringMode: payload ? _.get(payload, 'feature_flags.external_steering_mode', false) : isEdit ? _.get(props.programDetails, 'feature_flags.external_steering_mode', false) : '',
      cfg: payload ? _.get(payload, 'feature_flags.cfg', false) : isEdit ? _.get(props.programDetails, 'feature_flags.cfg', false) : '',
      dtg: payload ? _.get(payload, 'feature_flags.dtg', false) : isEdit ? _.get(props.programDetails, 'feature_flags.dtg', false) : '',
      tpcName: payload ? _.get(payload, 'feature_flags.tpc_name', '') : isEdit ? _.get(props.programDetails, 'feature_flags.tpc_name', '') : '',
      tpcProgram: payload ? _.get(payload, 'feature_flags.tpc_program', '') : isEdit ? _.get(props.programDetails, 'feature_flags.tpc_program', '') : '',
      rsoc: payload ? _.get(payload, 'feature_flags.rsoc', '') : isEdit ? _.get(props.programDetails, 'feature_flags.rsoc', '') : '',
      vls: payload ? _.get(payload, 'feature_flags.vls', '') : isEdit ? _.get(props.programDetails, 'feature_flags.vls', '') : '',
      potentialEarning: payload ? _.get(payload, 'feature_flags.potential_earnings_applicable_for_program', false) : isEdit ? _.get(props.programDetails, 'feature_flags.potential_earnings_applicable_for_program', false) : '',
      installerIntake: payload ? _.get(payload, 'feature_flags.installer_intake', false) : isEdit ? _.get(props.programDetails, 'feature_flags.installer_intake', false) : '',
      customerSupportView: payload ? _.get(payload, 'feature_flags.customer_support_verification', false) : isEdit ? _.get(props.programDetails, 'feature_flags.customer_support_verification', false) : '',
      incentiveCalc: payload ? _.get(payload, 'feature_flags.incentive_calculation_formulae', false) : isEdit ? _.get(props.programDetails, 'feature_flags.incentive_calculation_formulae', false) : '',
      eventTypes: payload ? _.get(payload, 'feature_flags.event_types', defaultEventTypes) : isEdit ? _.get(props.programDetails, 'feature_flags.event_types', defaultEventTypes) : defaultEventTypes,
      minEswBattery: payload ? _.get(payload, 'feature_flags.min_eSW_Battery', ''): isEdit ? _.get(props.programDetails, 'feature_flags.min_eSW_Battery', ''): '',
      minEswExportLimit: payload ? _.get(payload, 'feature_flags.min_eSW_ExportLimit', ''): isEdit ? _.get(props.programDetails, 'feature_flags.min_eSW_ExportLimit', ''): '',
      minEswPv: payload ? _.get(payload, 'feature_flags.min_eSW_PV', ''): isEdit ? _.get(props.programDetails, 'feature_flags.min_eSW_PV', ''): '',
      unsupporedSolarMicros: payload ? _.get(payload, 'feature_flags.unsupported_solar_micros', []) : isEdit ? _.get(props.programDetails, 'feature_flags.unsupported_solar_micros', []) : [],
      minSiteStage: payload ? _.get(payload, 'feature_flags.min_site_stage', 4) : isEdit ? _.get(props.programDetails, 'feature_flags.min_site_stage', 4): 4,
      allowedSites: payload ? _.get(payload, 'feature_flags.allowed_sites', []) : isEdit ? _.get(props.programDetails, 'feature_flags.allowed_sites', []) : [],
      allowedZipCodes: payload ? _.get(payload, 'feature_flags.allowed_zip', []) : isEdit ? _.get(props.programDetails, 'feature_flags.allowed_zip', []) : [],
      eventSubTypes: payload ? _.get(payload, 'feature_flags.event_subtypes', defaultEventSubTypes) : isEdit ? _.get(props.programDetails, 'feature_flags.event_subtypes', defaultEventSubTypes) : defaultEventSubTypes,
      openAdr: payload ? _.get(payload, 'feature_flags.openadr_service_enabled', false) : isEdit ? _.get(props.programDetails, 'feature_flags.openadr_service_enabled', false) : '',
      openADREnrollmentService: payload ? _.get(payload, 'feature_flags.openADR_enrollment_service', false) : isEdit ? _.get(props.programDetails, 'feature_flags.openADR_enrollment_service', false) : '',
      openADREventService: payload ? _.get(payload, 'feature_flags.openADR_event_service', false) : isEdit ? _.get(props.programDetails, 'feature_flags.openADR_event_service', false) : '',
      openADRReportService: payload ? _.get(payload, 'feature_flags.openADR_report_service', false) : isEdit ? _.get(props.programDetails, 'feature_flags.openADR_report_service', false) : '',
      openADROptOutService: payload ? _.get(payload, 'feature_flags.openADR_optOut_service', false) : isEdit ? _.get(props.programDetails, 'feature_flags.openADR_optOut_service', false) : '',
      autoValidation: (isEdit) ? _.get(props.programDetails, 'feature_flags.auto_approve_validations', autoValidation) : [],
      minimumRateWatt: payload ? _.get(payload, 'feature_flags.minimum_rate_watt_percent', 10) : isEdit ? _.get(props.programDetails, 'feature_flags.minimum_rate_watt_percent', 10) : '',
      retryTimeInterval: payload ? _.get(payload, 'feature_flags.command_retry_time_interval_post_start', 0) : isEdit ? _.get(props.programDetails, 'feature_flags.command_retry_time_interval_post_start', 0) : '',
      eventLeadTime: payload ? _.get(payload, 'feature_flags.event_lead_time', 0) : isEdit ? _.get(props.programDetails, 'feature_flags.event_lead_time', 0) : '',
      activateRealTimeDispatch: payload ? _.get(payload, 'feature_flags.activate_real_time_dispatch', false) : isEdit ? _.get(props.programDetails, 'feature_flags.activate_real_time_dispatch', false) : '',
      programStandardization: payload ? _.get(payload, 'feature_flags.program_standardization', false) : isEdit ? _.get(props.programDetails, 'feature_flags.program_standardization', false) : '',
      sftpEnrollment: payload ? _.get(payload, 'feature_flags.sftp_enrollment_files_to_energyhub', false) : isEdit ? _.get(props.programDetails, 'feature_flags.sftp_enrollment_files_to_energyhub', false) : '',
      autounenrollment: payload ? _.get(payload, 'feature_flags.auto_unenroll_sites', false) : isEdit ? _.get(props.programDetails, 'feature_flags.auto_unenroll_sites', false) : '',
      enrolledHomeOwnerexp: payload ? _.get(payload, 'feature_flags.enrolled_ho_exp', false) : isEdit ? _.get(props.programDetails, 'feature_flags.enrolled_ho_exp', false) : '',
      enactEnabled: payload ? _.get(payload, 'feature_flags.enact_enabled', false) : isEdit ? _.get(props.programDetails, 'feature_flags.enact_enabled', false) : '',
      enhoAppIntake: payload ? _.get(payload, 'feature_flags.enho_app_intake', false) : isEdit ? _.get(props.programDetails, 'feature_flags.enho_app_intake', false) : '',
      solarHomeOwner: payload ? _.get(payload, 'feature_flags.solar_only_ho_exp', false) : isEdit ? _.get(props.programDetails, 'feature_flags.solar_only_ho_exp', false) : '',
      solarStorageHomeOwner: payload ? _.get(payload, 'feature_flags.solar_storage_ho_exp', false) : isEdit ? _.get(props.programDetails, 'feature_flags.solar_storage_ho_exp', false) : '',
      storageOnlyHomeOwner: payload ? _.get(payload, 'feature_flags.storage_only_ho_exp', false) : isEdit ? _.get(props.programDetails, 'feature_flags.storage_only_ho_exp', false) : '',
      syncEnrollments: payload ? _.get(payload, 'feature_flags.sync_enrollments', false) : isEdit ? _.get(props.programDetails, 'feature_flags.sync_enrollments', false) : '',
      enableBulkEvent: payload ? _.get(payload, 'feature_flags.enable_bulk_event_dispatch', false) : isEdit ? _.get(props.programDetails, 'feature_flags.enable_bulk_event_dispatch', false) : '',
      pcuBinWidth: payload ? _.get(payload, 'feature_flags.pcu_bin_width', 0) : isEdit ? _.get(props.programDetails, 'feature_flags.pcu_bin_width', 0) : '',
      pcuPollingInterval: payload ? _.get(payload, 'feature_flags.pcu_polling_interval', 0) : isEdit ? _.get(props.programDetails, 'feature_flags.pcu_polling_interval', 0) : '',
      rgmBinWidth: payload ? _.get(payload, 'feature_flags.rgm_bin_width', 0) : isEdit ? _.get(props.programDetails, 'feature_flags.rgm_bin_width', 0) : '',
      rgmPollingInterval: payload ? _.get(payload, 'feature_flags.rgm_polling_interval', 0) : isEdit ? _.get(props.programDetails, 'feature_flags.rgm_polling_interval', 0) : '',
      reportingIntervalPeriod: payload ? _.get(payload, 'feature_flags.reporting_interval_period', 0) : isEdit ? _.get(props.programDetails, 'feature_flags.reporting_interval_period', 0) : '',
      minEventDuration: payload ? _.get(payload, 'feature_flags.min_event_duration', 0) / 1000 : isEdit ? _.get(props.programDetails, 'feature_flags.min_event_duration', 0) / 1000 : 60,
      controlType: payload ? _.get(payload, 'feature_flags.control_type', []) : isEdit ? _.get(props.programDetails, 'feature_flags.control_type', []) : '',
      functions: payload ? _.get(payload, 'feature_flags.functions', []) : isEdit ? _.get(props.programDetails, 'feature_flags.functions', []) : '',
      evseControlType: payload ? _.get(payload, 'feature_flags.evse_control_type', 'VPP_API') : isEdit ? _.get(props.programDetails, 'feature_flags.evse_control_type', 'VPP_API') : 'VPP_API',
      dummyValue: '',
      liveStreamTelemetryEnabled: payload ? _.get(payload, 'feature_flags.live_stream_telemetry_enabled', false) : isEdit ? _.get(props.programDetails, 'feature_flags.live_stream_telemetry_enabled', false) : '',
      liveStreamTelemetryFrequency: payload ? _.get(payload, 'feature_flags.live_stream_telemetry_frequency', 0) : isEdit ? _.get(props.programDetails, 'feature_flags.live_stream_telemetry_frequency', 0) : '',
      liveStreamTelemetryCustomerName: payload ? _.get(payload, 'feature_flags.live_stream_telemetry_customer_name', []) : isEdit ? _.get(props.programDetails, 'feature_flags.live_stream_telemetry_customer_name', []) : [],
      batteryLockConfig: (() => {
        const value = payload ? _.get(payload, 'battery_lock_config.DISPATCH.hours_duration', '') : isEdit ? _.get(props.programDetails, 'battery_lock_config.DISPATCH.hours_duration', '') : ''
        return (value === null || value === -1 || value === "") ? "" : value
      })(),
      csipEnabled: payload ? _.get(payload, 'feature_flags.csip_enabled', false) : isEdit ? _.get(props.programDetails, 'feature_flags.csip_enabled', false) : false,
      csipEnvoyEnabled: payload ? _.get(payload, 'feature_flags.csip_envoy_enabled', false) : isEdit ? _.get(props.programDetails, 'feature_flags.csip_envoy_enabled', false) : false,
      csipInBandRegEnabled: payload ? _.get(payload, 'feature_flags.csip_in_band_reg_enabled', false) : isEdit ? _.get(props.programDetails, 'feature_flags.csip_in_band_reg_enabled', false) : '',
      csipDirectClient: payload ? _.get(payload, 'feature_flags.csip_direct_client', false) : isEdit ? _.get(props.programDetails, 'feature_flags.csip_direct_client', false) : false,
      profileList: payload ? _.get(payload, 'feature_flags.csip_profile', []) : isEdit ? _.get(props.programDetails, 'feature_flags.csip_profile', []) : [],
      capabilityList: payload ? _.get(payload, 'feature_flags.csip_der_capability_fields', []) : isEdit ? _.get(props.programDetails, 'feature_flags.csip_der_capability_fields', []) : [],
      settingsList: payload ? _.get(payload, 'feature_flags.csip_der_settings_fields', []) : isEdit ? _.get(props.programDetails, 'feature_flags.csip_der_settings_fields', []) : [],
      controlList: payload ? _.get(payload, 'feature_flags.csip_allowed_controls', []) : isEdit ? _.get(props.programDetails, 'feature_flags.csip_allowed_controls', []) : [],
      telemetryList: payload ? _.get(payload, 'feature_flags.csip_mup_fields', []) : isEdit ? _.get(props.programDetails, 'feature_flags.csip_mup_fields', []) : [],
      statusList: payload ? _.get(payload, 'feature_flags.csip_der_status_fields', []) : isEdit ? _.get(props.programDetails, 'feature_flags.csip_der_status_fields', []) : [],
      enableCollectTelemetry: payload ? _.get(payload, 'feature_flags.enable_collect_telemetry', true) : isEdit ? _.get(props.programDetails, 'feature_flags.enable_collect_telemetry', true) : '',
      enableForecast: payload ? _.get(payload, 'feature_flags.enable_forecast', false) : isEdit ? _.get(props.programDetails, 'feature_flags.enable_forecast', false) : '',
    }
    return initalVal
  }
  const FormikDatePicker = ({ data, name, form: { setFieldValue }, field: { value }, ...rest }) => {
    return (
      <DatePicker
        autoOk
        disableToolbar
        openTo="year"
        variant="inline"
        label={renderDurationLabel()}
        format="dd-MM-yyyy"
        className={classes.field}
        onChange={(value) => {
          setFieldValue('duration', value)
        }}
        disablePast
        value={value || null}
        invalidLabel=''
        animateYearScrolling={false}
        views={["year", "month", "date"]}
        InputProps={{
          classes: { root: classes.input, underline: classes.underline },
          endAdornment: <span className={classes.crossIcon} onClick={() => setFieldValue('duration', null)}><ClearIcon /></span>
        }}
      />
    )
  }

  const getUtilitesOptions = (obj, values) => {
    let utilitiesOptions = []
    obj.options.forEach(option => {
      if (values['location'] === ALL) {
        utilitiesOptions.push(<MenuItem value={option.value} label={option.label}>{option.label}</MenuItem>)
      }
      else if (option.states.includes(values['location']) || option.states.includes(ALL)) {
        utilitiesOptions.push(<MenuItem value={option.value} label={option.label}>{option.label}</MenuItem>)
      }
    })
    if (utilitiesOptions.length > 0) {
      return utilitiesOptions
    }
    return <MenuItem value="noUtilityzFound" label="No Utility Found" disabled>No Utility Found</MenuItem>
  }

  const getForm = (obj, values, setFieldValue, errors) => {

    const handleAutoValidation = (value, index, type) => {
      let itemType = values.autoValidation[index]?.type
      if (itemType !== PRE_APPROVED_AUTH) {
        if ((!/^[0-9;]+$/.test(value)) && (typeof (value) !== 'boolean')) {
          if (value !== '') {
            return
          }
        }
      }

      setFieldValue('autoValidation', values.autoValidation.map((item, currentIndex) => {
        if (index === currentIndex && type === 'enabled') {
          return { ...item, [type]: value }
        }
        else if (index === currentIndex && type === 'values') {
          return { ...item, [type]: value.split(';') }
        }
        return item
      }))

    }

    const onCheckBoxChecked = (event, obj) => {
      if (obj.name === 'openAdr' && !event.target.checked) {
        setFieldValue('openADREventService', false)
        setFieldValue('openADRReportService', false)
        setFieldValue('openADROptOutService', false)
        setFieldValue('openADREnrollmentService', false)
      }

      setFieldValue(obj.name, event.target.checked)
    }

    const checkboxDisabled = (obj, values) => {
      let disabled = obj.disabled

      obj.disableDependency && obj.disableDependency.map(item => {
        if (values[item] === true) {
          disabled = false
        }
      })
      return disabled
    }

    function autoEnrollmentValidation() {
      return (
        <>
          <Button color="primary" variant="outlined" startIcon={values[obj.id] === 'NONE' ? <RadioButtonChecked /> : <RadioButtonUnchecked />} className={`${classes.enrolmentButton} ${values[obj.id] === 'NONE' ? classes.active : ''}`} disableElevation disableRipple onClick={() => { setFieldValue(obj.name, 'NONE'); setShowCheckbox(false); }}><Box className={classes.buttonText}>None</Box></Button>

          <Button color="primary" variant='outlined' className={classes.enrolmentButton} disableElevation disableRipple>
            <Grid >
              <Box display='flex' justifyContent='flex-start'>
                <Button color="primary" startIcon={values[obj.id] === 'AUTO_ENROLLMENT' ? <RadioButtonChecked /> : <RadioButtonUnchecked />} className={`${classes.autoEnrollmentButton} ${values[obj.id] === 'AUTO_ENROLLMENT' ? classes.active : ''}`} disableElevation disableRipple onClick={() => { setFieldValue(obj.name, 'AUTO_ENROLLMENT'); setShowCheckbox(showCheckbox); }}><Box className={classes.buttonText}>Auto Enrollment</Box><br />
                </Button>
              </Box >
              {(showCheckbox || values[obj.id] === 'AUTO_ENROLLMENT') &&
                values.autoValidation.map((item, index) =>
                  <Box>
                    <FormControlLabel
                      className={classes.checkBoxleave}
                      control={
                        <Checkbox
                          color='primary'
                          checked={item.enabled}
                          onChange={(e) => handleAutoValidation(e.target.checked, index, 'enabled')}
                        />
                      }
                      label={<Box className={classes.labelType}>{validationLabel[item.type]}</Box>}
                    />
                    <br />
                    {(!item.noTextField && item.values !== null) && <div>
                      <TextField
                        className={classes.textField}
                        placeholder='Enter value here'
                        fullWidth
                        multiline={true}
                        disabled={!item.enabled}
                        value={item.values.length > 0 ? item.values.join(';') : []}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault()
                          }
                        }}
                        onChange={(e) => handleAutoValidation(e.target.value, index, 'values')}
                      />
                    </div>
                    }
                    <br />
                  </Box>
                )}
            </Grid>
            <br />
          </Button > <br />
        </>
      )
    }

    const handleAssetChange = (e, field) => {
      let availableAsset
      if (field === 'controlType') {
        if (e.target.checked) {
          availableAsset = [...values.controlType, e.target.name]
        } else {
          availableAsset = values.controlType.filter(value => value !== e.target.name)
        }
        setFieldValue('controlType', availableAsset)
      } else if (field === 'systemAccessList') {
        if(e.target.checked){
          availableAsset = [...values.systemAccessList, e.target.name]
        } else {
          availableAsset = values.systemAccessList.filter(item => item !== e.target.name)
        }
        setFieldValue('systemAccessList', availableAsset)
      } else {
        if (e.target.checked) {
          availableAsset = [...values.functions, e.target.name]
        } else {
          availableAsset = values.functions.filter(value => value !== e.target.name)
        }

        if (e.target.name === 'EVSE') {
          setFieldValue('evseControlType', 'VPP_API')
          setIsOcpp(false)
        }

        setFunctions(availableAsset)
        let availableEventTypes = values.eventTypes
        let availableEventSubTypes = values.eventSubTypes
        if (!availableAsset.includes('PV')) {
          availableEventTypes = availableEventTypes.filter(eventType => eventType !== 'pv_curtailment')
          availableEventSubTypes = availableEventSubTypes.filter(item => {
            return item.name !== 'PV_Curtailment'
          })
        }
        if (!availableAsset.includes('BATTERY')) {
          availableEventTypes = availableEventTypes.filter(eventType => eventType !== 'BATTERY_CHARGE' && eventType !== 'BATTERY_DISCHARGE' && eventType !== 'IDLE')
          availableEventSubTypes = availableEventSubTypes.filter(item => {
            return !batteryEventSubTypes.includes(item.name)
          })
        }
        if (!availableAsset.includes('HP')) {
          availableEventTypes = availableEventTypes.filter(eventType => eventType !== 'hp_control')
          availableEventSubTypes = availableEventSubTypes.filter(item => {
            return !hpEventSubTypes.includes(item.name)
          })
        }
        if (!availableAsset.includes('EVSE')) {
          availableEventTypes = availableEventTypes.filter(eventType => eventType !== 'evse_control')
          availableEventSubTypes = availableEventSubTypes.filter(item => {
            return !evseEventSubTypes.includes(item.name)
          })
        }
        if (!availableAsset.includes('HVAC')) {
          availableEventTypes = availableEventTypes.filter(eventType => eventType !== 'hvac_control')
          availableEventSubTypes = availableEventSubTypes.filter(item => {
            return !hvacEventSubTypes.includes(item.name)
          })
        }
        setFieldValue('eventTypes', availableEventTypes)
        setFieldValue('eventSubTypes', availableEventSubTypes)
        setFieldValue('functions', availableAsset)
      }
    }

    return (
      <Box className={classes.fieldWrapper}>
        {obj.type === 'switch' ?
          <>
            {obj.multiValues ?
              <Box display="flex" flexDirection="row" alignItems="center" ml={marginLeft}>
                <Grid item xs={6}>
                  <Box component="span" className={classes.switchLabel}>{obj.label}</Box>
                </Grid>
                <Grid item xs={6}>
                  <Box display="flex" justifyContent="center" width="100%" mx={2}>
                    <FormControlLabel
                      control={<Switch color="primary" checked={values[obj.id]} disabled={checkboxDisabled(obj, values)} onChange={(e) => onCheckBoxChecked(e, obj)} name={obj.name} />}
                    />
                  </Box>
                </Grid>
              </Box>
              : <FormControlLabel
                className={`${classes.formSwitch} ${!props.isSuperAdmin ? classes.adminSwitch : ''}`}
                control={<Switch color="primary" checked={values[obj.id]} disabled={checkboxDisabled(obj, values)} onChange={(e) => onCheckBoxChecked(e, obj)} name={obj.name} />}
                label={<span className={classes.switchLabel}>{obj.label}</span>}
                labelPlacement="start"
              />}
            {obj.divider && <Divider />}
          </>
          : obj.type === 'multiSwitch' ?
            <Box display="flex" flexDirection="row" alignItems="center" ml={marginLeft}>
              <Grid item xs={6}>
                <Box component="span" className={classes.switchLabel}>{obj.label}</Box>
              </Grid>
              <Grid item xs={6}>
                <Box className={classes.multiFieldValues}>
                  {obj.flagControls?.filter((flagControl) => !flagControl.type || (flagControl.type === AUTONOMOUS && isAutonomous)).map((flagControl) => (
                    <FormControlLabel
                      key={flagControl.id}
                      className={`${classes.programFlagCell} ${classes.formSwitch}`}
                      control={<Switch color="primary" checked={values[flagControl.id]} disabled={checkboxDisabled(obj, values)} onChange={(e) => onCheckBoxChecked(e, flagControl)} name={flagControl.name} />}
                      labelPlacement="start"
                    />
                  ))}
                </Box>
              </Grid>
            </Box>
            : obj.type === 'multiSubHeading' ?
              <>
                <Box className={classes.separator} />
                <Box className={classes.contentWrapper} p={0}>
                  <Box display="flex" flexDirection="row" width="100%">
                    <Grid item xs={6}>
                      <Box className={classes.programConfigSubHeading}> EVENT CONFIGURATION</Box>
                    </Grid>

                    <Grid item xs={6}>
                      <Box className={classes.eventConfigWrapper} style={{ justifyContent: props.isSuperAdmin ? '' : 'center' }} >
                        {props.isSuperAdmin && <Box className={`${classes.programDetaislCardCellValue} ${classes.programFlagWrapper}`}>PROGRAM</Box>}
                        <Box className={`${classes.fieldWrapper} ${classes.programFlagCell}`} style={{ width: isAutonomous ? '100%' : '50%' }}>
                          <Box className={`${classes.programDetaislCardCellValue} ${classes.programFlagCell}`} pb="10px">OVERRIDE</Box>
                          <Box display='flex' justifyContent='space-between'>
                            <Box className={`${classes.programDetaislCardCellValue} ${classes.programFlagCell}`} style={{ width: (isAutonomous && props.isSuperAdmin) ? '50%' : '100%' }}>One-Time</Box>
                            {props.isSuperAdmin && isAutonomous && <Box className={`${classes.programDetaislCardCellValue} ${classes.programFlagCell}`} width="50%">Recurring</Box>}
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  </Box>
                </Box>
                {obj.divider && <Divider />}
              </>
              : obj.type === 'subHeading' ?
                <>
                  <Box className={classes.separator} />
                  <Typography className={classes.subHeading}>{obj.label}</Typography>
                  {obj.divider && <Divider />}
                </>
                : obj.type === "multiButton" ?
                  <Box my={1} display="flex" justifyContent="flex-start" >
                    <Typography className={classes.labelSubheading} display='inline'>{obj.label}</Typography>
                    <Box>
                      <Button color="primary" variant="outlined" startIcon={values[obj.id] === 'SYSTEM_APPROVAL' ? <RadioButtonChecked /> : <RadioButtonUnchecked />} className={`${classes.enrolmentButton} ${values[obj.id] === 'SYSTEM_APPROVAL' ? classes.active : ''}`} disableElevation disableRipple onClick={() => { setFieldValue(obj.name, 'SYSTEM_APPROVAL'); setShowCheckbox(false); }}><Box className={classes.buttonText}>Systems Approval</Box></Button>
                      <Button color="primary" variant="outlined" startIcon={values[obj.id] === 'SYSTEM_ADDITION' ? <RadioButtonChecked /> : <RadioButtonUnchecked />} className={`${classes.enrolmentButton} ${values[obj.id] === 'SYSTEM_ADDITION' ? classes.active : ''}`} disableElevation disableRipple onClick={() => { setFieldValue(obj.name, 'SYSTEM_ADDITION'); setShowCheckbox(false); }}><Box className={classes.buttonText}>Systems Addition</Box></Button>
                      {values[obj.id] === 'AUTO_ENROLLMENT' ?
                        autoEnrollmentValidation()
                        : <Box>
                          <Button color="primary" variant="outlined" startIcon={values[obj.id] === 'AUTO_ENROLLMENT' ? <RadioButtonChecked /> : <RadioButtonUnchecked />} className={`${classes.enrolmentButton} ${values[obj.id] === 'AUTO_ENROLLMENT' ? classes.active : ''}`} disableElevation disableRipple onClick={() => { setFieldValue(obj.name, 'AUTO_ENROLLMENT'); setShowCheckbox(showCheckbox); }}><Box className={classes.buttonText} style={{ display: 'flex', alignContent: 'flex-start' }}>Auto Enrollment</Box><br /></Button>
                          <Button color="primary" variant="outlined" startIcon={values[obj.id] === 'NONE' ? <RadioButtonChecked /> : <RadioButtonUnchecked />} className={`${classes.enrolmentButton} ${values[obj.id] === 'NONE' ? classes.active : ''}`} disableElevation disableRipple onClick={() => { setFieldValue(obj.name, 'NONE'); setShowCheckbox(false); }}><Box className={classes.buttonText}>None</Box></Button>
                        </Box>
                      }

                    </Box>
                  </Box>
                  : obj.type === "multioption" ?
                    <>
                      <Grid container spacing={4}>
                        <Grid item xs={4}>
                          <Box className={classes.eventEditTypeBox}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  icon={<CheckBoxOutlineBlank fontSize="small" />}
                                  checkedIcon={<CheckBox fontSize="small" />}
                                  checked={values.eventTypes.includes(obj.value)}
                                  disabled={
                                    (isEdit && (isOcpp ||
                                      ((!functions.includes('PV') && obj.value === 'pv_curtailment') ||
                                        (!functions.includes('BATTERY') && (obj.value === 'BATTERY_CHARGE' || obj.value === 'BATTERY_DISCHARGE' || obj.value === 'IDLE')) ||
                                        (!functions.includes('HP') && obj.value === 'hp_control') ||
                                        (!functions.includes('EVSE') && obj.value === 'evse_control') ||
                                        (!functions.includes('HVAC') && obj.value === 'hvac_control'))
                                    ))
                                  }
                                  disableRipple
                                  disableTouchRipple
                                  disableFocusRipple
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      let availableEventTypes = [...values.eventTypes]
                                      availableEventTypes.push(obj.value)
                                      setFieldValue('eventTypes', availableEventTypes)
                                      if (obj.value === 'IDLE') {
                                        let availableEventSubTypes = values.eventSubTypes
                                        availableEventSubTypes.push({ name: 'Idle', min_target_soc: 100, max_target_soc: 100 })
                                        setFieldValue('eventSubTypes', availableEventSubTypes)
                                      }
                                      else if (obj.value === 'pv_curtailment') {
                                        let availableEventSubTypes = values.eventSubTypes
                                        availableEventSubTypes.push({ name: 'PV_Curtailment', min_target_soc: 10, max_target_soc: 100 })
                                        setFieldValue('eventSubTypes', availableEventSubTypes)
                                      }
                                      else if (obj.value === 'export_limit') {
                                        let availableEventSubTypes = values.eventSubTypes
                                        availableEventSubTypes.push({ name: 'Export_Limit', min_target_soc: 10, max_target_soc: 100 })
                                        setFieldValue('eventSubTypes', availableEventSubTypes)
                                      }
                                      else if (obj.value === 'hvac_control') {
                                        let availableEventSubTypes = values.eventSubTypes
                                        availableEventSubTypes.push({ name: 'SETPOINT_OFFSET', min_target_soc: 10, max_target_soc: 100 })
                                        setFieldValue('eventSubTypes', availableEventSubTypes)
                                      }
                                    } else {
                                      let availableEventTypes = values.eventTypes.filter(item => item !== obj.value)
                                      setFieldValue('eventTypes', availableEventTypes)
                                      let availableEventSubTypes = values.eventSubTypes.filter(item => {
                                        if (obj.value === 'IDLE') {
                                          return item.name !== 'Idle'
                                        }
                                        else if (obj.value === 'pv_curtailment') {
                                          return item.name !== 'PV_Curtailment'
                                        }
                                        else if (obj.value === 'export_limit') {
                                          return item.name !== 'Export_Limit'
                                        }
                                        else if (obj.value === 'hvac_control') {
                                          return item.name !== 'SETPOINT_OFFSET'
                                        }
                                        else {
                                          return !(obj.options.map(option => option.value).includes(item.name))
                                        }
                                      })
                                      setFieldValue('eventSubTypes', availableEventSubTypes)
                                    }
                                  }}
                                  name={obj.value}
                                  color="primary"
                                />
                              }
                              label={<Box className={classes.eventTypeText}>{obj.label}</Box>}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={8}>
                          <Box display="flex" flexWrap="wrap">
                            {obj.options.map(option => (
                              <Box className={classes.eventSubTypeBox} style={{ padding: obj.hideSoc ? '0 8px' : '' }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      icon={<CheckBoxOutlineBlank fontSize="small" />}
                                      checkedIcon={<CheckBox fontSize="small" />}
                                      checked={values.eventSubTypes.find(obj => obj.name === option.value) && values.eventTypes.includes(obj.value) ? true : false}
                                      disabled={!values.eventTypes.includes(obj.value)}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          let availableEventSubTypes = [...values.eventSubTypes]
                                          availableEventSubTypes.push({
                                            name: option.value,
                                            min_target_soc: 10,
                                            max_target_soc: 100
                                          })
                                          setFieldValue('eventSubTypes', availableEventSubTypes)
                                        } else {
                                          let availableEventSubTypes = values.eventSubTypes.filter(item => item.name !== option.value)
                                          setFieldValue('eventSubTypes', availableEventSubTypes)
                                        }
                                      }}
                                      name={option.value}
                                      color="primary"
                                    />
                                  }
                                  label={<Box className={classes.subTypeBoxHeading}>{option.name}</Box>}
                                />
                                {obj.hideSoc ? <></> :
                                  <>
                                    <Box mb={1}>
                                      <Divider />
                                    </Box>
                                    <Box display="flex" justifyContent="space-between">
                                      <TextField
                                        id={option.value}
                                        name={option.value}
                                        disabled={!values.eventTypes.includes(obj.value) || !values.eventSubTypes.find(subtype => subtype.name === option.value)}
                                        value={(() => {
                                          const subType = values.eventSubTypes.find(subtype => subtype.name === option.value)
                                          return (subType && obj.value === 'BATTERY_CHARGE') ? subType?.max_target_soc : subType?.min_target_soc
                                        })()}
                                        defaultValue={(obj.value === 'BATTERY_CHARGE' ? '100' : '10')}
                                        InputLabelProps={{ shrink: true }}
                                        onBlur={(e) => {
                                          e.target.value = e.target.value === '' ? 10 : e.target.value > 100 ? 100 : e.target.value
                                          setFieldValue('dummyValue', e.target.value)
                                          if (obj.value === 'BATTERY_CHARGE') {
                                            let availableEventSubTypes = values.eventSubTypes.find(subtype => subtype.name === option.value)
                                            if (availableEventSubTypes)
                                              availableEventSubTypes.max_target_soc = e.target.value
                                            let newVal = values.eventSubTypes.map(subtype => {
                                              if (subtype.name === availableEventSubTypes.name)
                                                return availableEventSubTypes
                                              return subtype
                                            })
                                            setFieldValue('eventSubTypes', newVal)
                                          } else if (obj.value === 'BATTERY_DISCHARGE') {
                                            let availableEventSubTypes = values.eventSubTypes.find(subtype => subtype.name === option.value)
                                            if (availableEventSubTypes)
                                              availableEventSubTypes.min_target_soc = e.target.value
                                            let newVal = values.eventSubTypes.map(subtype => {
                                              if (subtype.name === availableEventSubTypes.name)
                                                return availableEventSubTypes
                                              return subtype
                                            })
                                            setFieldValue('eventSubTypes', newVal)
                                          } else {

                                          }
                                        }}
                                        onChange={(e) => {
                                          setFieldValue('dummyValue', e.target.value)
                                          e.target.value = e.target.value.replace(/\D/g, '')
                                          e.target.value = e.target.value ? (e.target.value).slice(0, 3) : e.target.value
                                          e.target.value = e.target.value ? e.target.value > 100 ? 100 : e.target.value : e.target.value
                                          if (obj.value === 'BATTERY_CHARGE') {
                                            let availableEventSubTypes = values.eventSubTypes.find(subtype => subtype.name === option.value)
                                            if (availableEventSubTypes)
                                              availableEventSubTypes.max_target_soc = e.target.value
                                            let newVal = values.eventSubTypes.map(subtype => {
                                              if (subtype.name === availableEventSubTypes.name)
                                                return availableEventSubTypes
                                              return subtype
                                            })
                                            setFieldValue('eventSubTypes', newVal)
                                          } else if (obj.value === 'BATTERY_DISCHARGE') {
                                            let availableEventSubTypes = values.eventSubTypes.find(subtype => subtype.name === option.value)
                                            if (availableEventSubTypes)
                                              availableEventSubTypes.min_target_soc = e.target.value
                                            let newVal = values.eventSubTypes.map(subtype => {
                                              if (subtype.name === availableEventSubTypes.name)
                                                return availableEventSubTypes
                                              return subtype
                                            })
                                            setFieldValue('eventSubTypes', newVal)
                                          } else {

                                          }
                                        }}
                                        fullWidth
                                        label={<Box className={classes.subTypeBoxLabel}>Target SoC (%)</Box>}
                                      />
                                    </Box>
                                  </>
                                }
                              </Box>
                            ))}
                          </Box>
                        </Grid>
                      </Grid>
                    </>
                    : obj.type === "evseControlType" ?
                      <Grid container spacing={4}>
                        <Grid item xs={4}>
                          <Box className={classes.eventEditTypeBox}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  icon={<CheckBoxOutlineBlank fontSize="small" />}
                                  checkedIcon={<CheckBox fontSize="small" />}
                                  checked={functions.includes('EVSE')}
                                  disabled={(!functions.includes('EVSE'))}
                                  disableRipple
                                  disableTouchRipple
                                  disableFocusRipple
                                  name={obj.value}
                                  color="primary"
                                />
                              }
                              label={<Box className={classes.eventTypeText}>{obj.label}</Box>}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={8}>
                          <Box display="flex" flexWrap="wrap">
                            {obj.options.map(option => (
                              <Box className={classes.eventSubTypeBox} style={{ padding: obj.hideSoc ? '0 8px' : '' }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      icon={<CheckBoxOutlineBlank fontSize="small" />}
                                      checkedIcon={<CheckBox fontSize="small" />}
                                      checked={(values[obj.id] === option.value) && functions.includes('EVSE')}
                                      disabled={!functions.includes('EVSE')}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setFieldValue('evseControlType', option.value)
                                          if (option.value === 'OCPP') {
                                            setFieldValue('functions', ['EVSE'])
                                            setFieldValue('eventTypes', [])
                                            setFieldValue('eventSubTypes', [])
                                            setFunctions(['EVSE'])
                                            setIsOcpp(true)
                                          } else {
                                            setIsOcpp(false)
                                          }
                                        }
                                      }}
                                      name={option.value}
                                      color="primary"
                                    />
                                  }
                                  label={<Box className={classes.subTypeBoxHeading}>{option.name}</Box>}
                                />
                              </Box>
                            ))}
                          </Box>
                        </Grid>
                      </Grid>
                      : obj.type === "multioptionHeading" ?
                        <Box mt={2} ml={marginLeft}>
                          <Grid container xs={12}>
                            <Grid item xs={4}>
                              <Box className={classes.programDetailsCardCellKey}>Event Type</Box>
                            </Grid>
                            <Grid item xs={8}>
                              <Box className={classes.programDetailsCardCellKey} mx={2}>Event Subtype</Box>
                            </Grid>
                          </Grid>
                        </Box>
                        : obj.type === "text" ?
                          obj.id === 'maxEventDuration' || obj.id === 'minEventDuration' ?
                            <>
                              <Box display="flex" flexDirection="row" alignItems="center" ml={marginLeft}>
                                <Grid item xs={6}>
                                  <Box component="span" className={classes.switchLabel}>{obj.label}</Box>
                                </Grid>
                                <Grid item xs={6}>
                                  <Box className={`${classes.multiFieldValues} ${classes.inputFieldWrapper}`}>
                                    {obj.inputs.map((input, index) => (
                                      (((input === 'maxEventDurationDefault' || input === 'minEventDurationDefault') && props.isSuperAdmin) || ((input === 'maxEventDurationRecurring' || input === 'minEventDurationRecurring') && isAutonomous) || (input === 'maxEventDurationProgram' || input === 'minEventDurationProgram')) &&
                                      <TextField
                                        key={index}
                                        id={`${obj.id}-${input}`}
                                        name={obj.name}
                                        className={`${classes.formSwitch} ${classes.fieldWidth}`}
                                        InputProps={{
                                          classes: { root: classes.maxEventDurationInput, underline: classes.underline },
                                          type: obj.type === 'number' ? 'number' : 'text'
                                        }}
                                        value={(values[input]) ? values[input] : ''}
                                        onChange={(e) => {
                                          handleValueChange(input, e.target.value)
                                          setFieldValue(input, e.target.value)
                                        }}
                                      />
                                    ))}
                                  </Box>
                                </Grid>
                              </Box>
                              {helperText === '' && obj.divider && <Divider />}
                            </>
                            :
                            (obj.id === 'helperText') ?
                              <>
                                <div className={classes.helperText}> {helperText} </div>
                                {obj.divider && <Divider />}
                              </>
                              :
                              (obj.flag) &&
                              <Box ml={marginLeft}>
                                <TextField
                                  id={obj.id}
                                  name={obj.name}
                                  label={obj.label}
                                  className={classes.field}
                                  multiline
                                  rows={1}
                                  rowsMax={3}
                                  InputProps={{
                                    classes: { root: classes.input, underline: classes.underline },
                                    type: obj.type === 'number' ? 'number' : 'text'
                                  }}
                                  disabled={checkboxDisabled(obj, values)}
                                  value={values[obj.id] !== null ? values[obj.id] : '-'}
                                  onChange={(e) => {
                                    if (obj.name === "vls" || obj.name === "rsoc" || obj.name === "minSiteStage") {
                                      e.target.value = e.target.value.replace(/\D/g, '')
                                      if (obj.name === "rsoc") {
                                        e.target.value = e.target.value ? e.target.value > 100 ? 100 : e.target.value : e.target.value
                                      } else if(obj.name === "vls"){
                                        e.target.value = e.target.value ? e.target.value > 25 ? 25 : e.target.value : e.target.value
                                      } else {
                                        e.target.value = e.target.value ? e.target.value > 5 ? 5 : e.target.value : e.target.value
                                      }
                                    }
                                    setFieldValue(obj.name, e.target.value)
                                  }}
                                  onBlur={(e) => {
                                    if (obj.name === 'allowedSites' || obj.name === 'allowedZipCodes' || obj.name === 'liveStreamTelemetryCustomerName' || obj.name === 'unsupporedSolarMicros') {
                                      setFieldValue(obj.name, handleString(e.target.value, obj.name))
                                    } else if (obj.name === 'vls') {
                                      if (e.target.value !== "" && e.target.value < 5) {
                                        setFieldValue(obj.name, 5)
                                      }
                                    }
                                  }}
                                />
                              </Box>
                          : obj.type === "checkboxes" ? (
                              <Box mt={2} ml={marginLeft}>
                                <Grid container xs={12} alignItems='center'>
                                  <Grid item xs={4}>
                                    <Box className={classes.programDetailsCardCellKey}>{obj.label}</Box>
                                  </Grid>
                                  <Grid items xs={8}>
                                    <Box mx={2}>
                                      <FormGroup className={classes.formGroup}>
                                        {obj.options.map((option) => {
                                          return <FormControlLabel
                                            classes={{ label: classes.formControlLabel }}
                                            control=
                                            {<Checkbox color="primary" size="small"
                                              checked={values[obj.id].includes(option.value)}
                                              disabled={isOcpp && (option.value !== 'EVSE' && option.value !== CLOUD_API && option.value !== LOCAL_API && option.value !== OWNER && option.value !== HOST)}
                                              onChange={(e) => handleAssetChange(e, obj.id)}
                                              name={option.value}
                                            />}
                                            label={option.label}
                                          />
                                        })}
                                      </FormGroup>
                                    </Box>
                                  </Grid>
                                </Grid>
                                <Typography className={classes.errorMessage}>{errors[obj.id]}</Typography>
                              </Box>
                            
                          ) 
                          : obj.type === 'multiText' ? (
                            <Box mt={2} ml={marginLeft} mb={2}>
                               <Grid container xs={12} alignItems='center'>
                                <Grid item xs={4}>
                                  <Box className={classes.programDetailsCardCellKey}>{obj.label}</Box>
                                </Grid>
                                <Grid items xs={6}>
                                  <Box className={classes.fieldWrapper}>
                                  {obj.options.map((item, index) => 
                                    <Box className={classes.multiFieldValues}>
                                      <TextField 
                                        name={item.name}
                                        label={item.label}
                                        className={classes.textField}
                                        fullWidth
                                        multiline={true} 
                                        value={values[item.name]}
                                        disabled={item.dependency === 'export_limit' ? !values.eventTypes.includes(item.dependency) : !functions.includes(item.dependency)}
                                        onChange={(e) => setFieldValue(item.name, e.target.value)}
                                        />
                                    </Box>
                                  )}
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>
                          )
                          : null
        }
      </Box >

    )
  }

  const renderEnrollmentConfiguration = () => {
    return (
      <>
        <Box className={classes.enrollmentConfigurationHeader}>APPLICATION SUBMISSION (SYSTEMS APPROVAL)</Box>
        <Box style={{ color: '#545455' }}>Submitting application via <b>ENHO App</b> :</Box>
        <Formik
          initialValues={{
            enrollmentConfiguration: null,
          }}
          onSubmit={(data, { resetForm }) => {
            if (_.get(data, 'configuration') !== null) {
              setLoading(true)
              programService.postProgramEnrollmentConfigRequest(props.programId, _.get(data, 'enrollmentConfiguration', ''), props.accountId)
                .then((data) => {
                  setLoading(false)
                  setOpen(true)
                  setMessage("Application Fields Updated Successfully.")
                  setMessageType(SUCCESS)
                  document.getElementById('enrollmentConfigFile').value = null
                  resetForm()
                })
                .catch((err) => {
                  errorCb(err)
                })
            }
          }}>
          {(formikNew) => (
            <Form>
              <Box className={classes.fileUploadWrapper}>
                <Box className={classes.fileUploadContent}>
                  <Typography className={classes.fileUploadLabel}> <img src={programDetailsCsvFile} className={classes.icons} alt="" style={{ marginRight: '10px' }} /> Application Fields CSV File</Typography>
                  <Box display="flex" flexDirection='column' justifyContent="center" alignItems="flex-end" flexWrap="wrap">
                    <UploadFile
                      isCSV={true}
                      onValueChange={(file) => {
                        formikNew.setFieldValue('enrollmentConfiguration', file)
                      }}
                      uploadId='enrollmentConfigFile'
                    ></UploadFile>
                    <Box className={classes.link} display="flex" alignItems='center' onClick={() => downloadTemplate('applicationCSV')}>
                      <Box mr={1} display='flex'>
                        <img src={download} alt="" height={15} />
                      </Box>
                      <Box>Download template</Box>
                    </Box>
                    <Box className={classes.link} display="flex" alignItems='center' onClick={() => downloadRecentlyUploadedFile('applicationCSV')}>
                      <Box mr={1} display='flex'>
                        <img src={download} alt="" height={15} />
                      </Box>
                      <Box>Download recently uploaded file</Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box className={classes.saveButtonWrapper}>
                <AppButton text='SAVE' minHeight='0px' className={`${classes.saveButton} ${formikNew.dirty ? '' : classes.disable} `} type="submit" />
              </Box>
            </Form>)}
        </Formik>
        <Formik
          initialValues={{
            enrollment_forms: null,
            tandc_forms: null
          }}
          onSubmit={(data) => {
            if (_.get(data, 'enrollment_forms') !== null) {
              let payload = {
                program_enrollment_form_metadata_id: _.get(props.programDetails, 'program_enrollment_form_metadata_id', ''),
                file: _.get(data, 'enrollment_forms'),
                program_file_key: 'enrollment_forms',
                accountId: props.accountId
              }
              setLoading(true)
              programService.postProgramFilesRequest(payload)
                .then(() => {
                  if (_.get(data, 'tandc_forms') !== null) {
                    let payload = {
                      program_enrollment_form_metadata_id: _.get(props.programDetails, 'program_enrollment_form_metadata_id', ''),
                      file: _.get(data, 'tandc_forms'),
                      program_file_key: 'tandc_forms',
                      accountId: props.accountId
                    }
                    setLoading(true)
                    programService.postProgramFilesRequest(payload)
                      .then(() => {
                        setLoading(false)
                        setOpen(true)
                        setMessage("Terms and Conditions Updated Successfully.")
                        setMessageType(SUCCESS)
                      })
                      .catch((err) => {
                        errorCb(err)
                      })
                  }
                  setLoading(false)
                  setOpen(true)
                  setMessage("Terms and Conditions Updated Successfully.")
                  setMessageType(SUCCESS)
                })
                .catch((err) => {
                  errorCb(err)
                })
            }
            if (_.get(data, 'tandc_forms') !== null && _.get(data, 'enrollment_forms') === null) {
              let payload = {
                program_enrollment_form_metadata_id: _.get(props.programDetails, 'program_enrollment_form_metadata_id', ''),
                file: _.get(data, 'tandc_forms'),
                program_file_key: 'tandc_forms',
                accountId: props.accountId
              }
              setLoading(true)
              programService.postProgramFilesRequest(payload)
                .then((data) => {
                  setLoading(false)
                  setOpen(true)
                  setMessage("Terms and Conditions Updated Successfully.")
                  setMessageType(SUCCESS)
                })
                .catch((err) => {
                  errorCb(err)
                })
            }
          }}>
          {(formikNew) => (
            <Form>
              <Box className={classes.fileUploadWrapper}>
                <Box className={classes.fileUploadContent}>
                  <Typography className={classes.fileUploadLabel}> <img src={termsAndConditionsFile} className={classes.icons} alt="" style={{ marginRight: '10px' }} /> Program Terms and Conditions </Typography>
                  <UploadFile
                    isCSV={false}
                    onValueChange={(file) => {
                      formikNew.setFieldValue('tandc_forms', file)
                    }}
                  ></UploadFile>
                </Box>
                <Box className={classes.fileUploadContent}>
                  <Typography className={classes.fileUploadLabel}> <img src={termsAndConditionsFile} className={classes.icons} alt="" style={{ marginRight: '10px' }} /> Enphase Terms and Conditions </Typography>
                  <UploadFile
                    isCSV={false}
                    onValueChange={(file) => {
                      formikNew.setFieldValue('enrollment_forms', file)
                    }}
                  ></UploadFile>
                </Box>
              </Box>
              <Box className={classes.saveButtonWrapper}>
                <AppButton text='SAVE' minHeight='0px' className={`${classes.saveButton} ${formikNew.dirty ? '' : classes.disable} `} type="submit" />
              </Box>
            </Form>)}
        </Formik>
        <Box className={classes.enrollmentConfigurationFooter}> <InfoOutlinedIcon /><span>Application would be approved via <b>Grid Services Manager</b></span></Box>
      </>
    )
  }

  const renderProgramDetails = () => {
    return (
      <>
        <Formik
          initialValues={{
            programDetails: null,
          }}
          onSubmit={(data, { resetForm, setFieldValue }) => {
            if (_.get(data, 'programDetails') !== null) {
              setLoading(true)
              programService.postProgramDetailsRequest(props.programId, _.get(data, 'programDetails', ''), props.accountId)
                .then((data) => {
                  setLoading(false)
                  setOpen(true)
                  setMessage("Program Details Updated Successfully.")
                  setMessageType(SUCCESS)
                  document.getElementById('programDetailsFile').value = null
                  resetForm()
                })
                .catch((err) => {
                  errorCb(err)
                })
            }
          }}>
          {(formikNew) => (
            <Form>
              <Box className={classes.fileUploadWrapper}>
                <Box className={classes.fileUploadContent}>
                  <Typography className={classes.fileUploadLabel}> <img src={programDetailsCsvFile} className={classes.icons} alt="" style={{ marginRight: '10px' }} /> Program Details CSV File</Typography>
                  <Box display="flex" flexDirection='column' justifyContent="center" alignItems="flex-end" flexWrap="wrap">
                    <UploadFile
                      isCSV={true}
                      onValueChange={(file) => {
                        formikNew.setFieldValue('programDetails', file)
                      }}
                      uploadId='programDetailsFile'
                    ></UploadFile>
                    <Box className={classes.link} display="flex" alignItems='center' onClick={() => downloadTemplate('programDetail')}>
                      <Box mr={1} display='flex'>
                        <img src={download} alt="" height={15} />
                      </Box>
                      <Box>Download template</Box>
                    </Box>
                    <Box className={classes.link} display="flex" alignItems='center' onClick={() => downloadRecentlyUploadedFile('programDetail')}>
                      <Box mr={1} display='flex'>
                        <img src={download} alt="" height={15} />
                      </Box>
                      <Box>Download recently uploaded file</Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box className={classes.saveButtonWrapper}>
                <AppButton text='SAVE' minHeight='0px' className={`${classes.saveButton} ${formikNew.dirty ? '' : classes.disable} `} type="submit" />
              </Box>
            </Form>)}
        </Formik>

      </>
    )
  }
  const getSwitchOption = (option, values, setFieldValue) => {
    return (
       <FormControlLabel
        className={`${classes.formSwitch1} ${!props.isSuperAdmin ? classes.adminSwitch : ''}`}
        control={<Switch color="primary" 
                         checked={values[option.name]} 
                         onChange={(e) => setFieldValue(option.name, e.target.checked)} 
                         name={option.name} 
                         disabled={option.name !== csipConfiguration.CSIP_ENABLED.name ? !values[csipConfiguration.CSIP_ENABLED.name] : false}
                />}
        label={<span className={classes.switchLabel}>{option.label}</span>}
        labelPlacement="start"
      />
    )
  }
 
  const getdropDownList = (obj, values, setFieldValue) => {
    const name = obj[0]
    return(
      <Grid item xs={12} className={classes.inputFieldWrapper} >
        <Grid item xs={4}>
          <Typography className={classes.labelSubheading} display='inline'>{CsipConfigOptions[name]}</Typography>
        </Grid>
        <Grid item xs={6} container spacing={2} >
          <Select
            fullWidth
            value={values[name] || ''}
            onChange={(e) => {
              setFieldValue(name, e.target.value);
            }}
            disabled={!values[csipConfiguration.CSIP_ENABLED.name]}
          >
            {obj[1].map((item) => (
              <MenuItem key={item} value={item}>
                <Box className={classes.buttonText}>{item}</Box>
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
    )
  }

  const getCheckBoxList = (obj, values, setFieldValue) => {
    const name = obj[0]
    return(
      <Box mt={2} ml={marginLeft} mb={2}>
        <Grid container xs={12} className={classes.labelWrapper}>
          <Grid item xs={4}>
            <Box className={classes.programDetailsCardCellKey}>{CsipConfigOptions[name]}</Box>
          </Grid>
          <Grid item xs={8} >
            <Grid container spacing={2}>
              {obj[1].map(item => (
                <Box className={classes.fieldWidth}>
                  <FormGroup className={classes.formGroup}>
                    <FormControlLabel
                      classes={{ label: classes.formControlLabel }}
                      control={
                        <Checkbox
                          color="primary"
                          size="small"
                          checked={Array.isArray(values[name]) && values[name].includes(item)}
                          name={item}
                          disabled={!values[csipConfiguration.CSIP_ENABLED.name]}
                          onChange={(e) => {
                            let currentValues = values[name] || []
                            if(e.target.checked){
                              setFieldValue(name, [...currentValues, item])
                            } else {
                              setFieldValue(name, currentValues.filter((val) => val !== item))
                            }
                          }}
                        />
                      }
                      label={item}
                    />
                  </FormGroup>
                </Box>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    )
  }
  
  const renderProgramInformation = () => {
    return (
      <Formik
        initialValues={initialValues()}
        enableReinitialize={true}
        validationSchema={props.isSuperAdmin ? superAdminSchema : adminSchema}
        validate={values => {
          let errors = {}
          values.autoValidation.map(item => {
            if (item.enabled && !item.noTextField && item.values !== null && (item.values.length === 0 || item.values[0] === '' || item.values[0] === null)) {
              errors.autoValidation = 'required value for the checked item'
            }
          })
          return errors
        }}
        onSubmit={(data) => {
          pushToDataLayer({ event: USERBEHAVIOURTRACKING, accountID: props.accountId, ...(isEdit ? { programID: props.programId } : {}) })
          let payload = {}
          const details = {
            name: _.get(data, 'name', ''),
            util_id: _.get(data, 'utilityName', ''),
            state: _.get(data, 'location', ''),
            program_name_admin_ui: renderUniqueName(data),
            program_end_date: _.get(data, 'duration', '') ? moment(_.get(data, 'duration', '')).format('YYYY-MM-DD') : isEdit ? 'SETPROGRAMENDDATETONULL' : null,
            max_system_enrollments: !(data && data.maxEnrollment) && isEdit ? 1000000000000000 : _.get(data, 'maxEnrollment', null),
            incentive_structure: {},
          }

          if (!isEdit) {
            details.requested_by = _.get(props.currentUser, 'id', '')
          }

          if (props.isSuperAdmin) {
            if (!isEdit) {
              details.account_id = _.get(data, 'account', '')
            }
            if (isEdit) {
              details.enrollment_web_link = _.get(data, 'enrollmentWebLink', '')
            }
          }

          details.incentive_structure[_.get(data, 'incentiveStructure', '')] = _.get(data, 'incentiveValue', '')
          payload = _.cloneDeep(details)
          payload.account_id = _.get(data, 'account', '')
          setLoading(true)
          setPayload(payload)

          if (isEdit) {
            if (props.isSuperAdmin) {
              details.feature_flags = {
                ...props.programDetails.feature_flags,
                event_ending_allowed_for_ongoing_event: _.get(data, 'stopEventProgram', ''),
                event_cancellation_allowed_for_upcoming_events: _.get(data, 'cancelEventProgram', ''),
                event_opt_in_opt_out_capability: _.get(data, 'eventOptProgram', ''),
                target_soc_override: _.get(data, 'targetSocOverrideProgram', ''),
                scheduled_power_override: _.get(data, 'scheduledPowerOverrideProgram', ''),
                max_event_duration: _.get(data, 'maxEventDurationProgram', '') * 1000,
                min_event_duration: _.get(data, 'minEventDurationProgram', '') * 1000,
                storm_guard_override: _.get(data, 'stormGuardOverrideProgram', ''),
                site_on_grid_off_grid_feature: _.get(data, 'siteGrid', ''),
                program_and_events: _.get(data, 'programAndEvent', ''),
                system_reports: _.get(data, 'systemReports', ''),
                forecasting_reports: _.get(data, 'forecastingReports', ''),
                user_reports: _.get(data, 'userReports', ''),
                system_enrollment_option: _.get(data, 'enrolmentOptions', ''),
                input_fields_terms_and_conditions_signatures: _.get(data, 'signatureTAndC', ''),
                committed_power_in_program: _.get(data, 'committedPower', ''),
                committed_energy_in_program: _.get(data, 'committedEnergy', ''),
                external_steering_mode: _.get(data, 'externalSteeringMode', ''),
                cfg: _.get(data, 'cfg', ''),
                dtg: _.get(data, 'dtg', ''),
                tpc_name: _.get(data, 'tpcName', ''),
                tpc_program: _.get(data, 'tpcProgram', ''),
                rsoc: _.get(data, 'rsoc', ''),
                vls: _.get(data, 'vls', ''),
                battery_reserve_soc_configurability: _.get(data, 'reserveSoc', ''),
                potential_earnings_applicable_for_program: _.get(data, 'potentialEarning', ''),
                installer_intake: _.get(data, 'installerIntake', ''),
                customer_support_verification: _.get(data, 'customerSupportView', ''),
                incentive_calculation_formulae: _.get(data, 'incentiveCalc', ''),
                event_types: _.get(data, 'eventTypes', []),
                event_subtypes: _.get(data, 'eventSubTypes', []),
                openadr_service_enabled: _.get(data, 'openAdr', ''),
                openADR_enrollment_service: _.get(data, 'openADREnrollmentService', ''),
                openADR_event_service: _.get(data, 'openADREventService', ''),
                openADR_report_service: _.get(data, 'openADRReportService', ''),
                openADR_optOut_service: _.get(data, 'openADROptOutService', ''),
                auto_approve_validations: _.get(data, 'autoValidation', ''),
                minimum_rate_watt_percent: _.get(data, 'minimumRateWatt', ''),
                command_retry_time_interval_post_start: _.get(data, 'retryTimeInterval', ''),
                live_stream_telemetry_enabled: _.get(data, 'liveStreamTelemetryEnabled', ''),
                live_stream_telemetry_frequency: _.get(data, 'liveStreamTelemetryFrequency', ''),
                live_stream_telemetry_customer_name: _.get(data, 'liveStreamTelemetryCustomerName', []),
                enable_collect_telemetry: _.get(data, 'enableCollectTelemetry', ''),
                enable_forecast: _.get(data, 'enableForecast', ''),
                event_lead_time: _.get(data, 'eventLeadTime', ''),
                activate_real_time_dispatch: _.get(data, 'activateRealTimeDispatch', ''),
                program_standardization: _.get(data, 'programStandardization', ''),
                sftp_enrollment_files_to_energyhub: _.get(data, 'sftpEnrollment', ''),
                auto_unenroll_sites: _.get(data, 'autounenrollment', ''),
                enrolled_ho_exp: _.get(data, 'enrolledHomeOwnerexp', ''),
                enact_enabled: _.get(data, 'enactEnabled', ''),
                enho_app_intake: _.get(data, 'enhoAppIntake', ''),
                solar_only_ho_exp: _.get(data, 'solarHomeOwner', ''),
                solar_storage_ho_exp: _.get(data, 'solarStorageHomeOwner', ''),
                storage_only_ho_exp: _.get(data, 'storageOnlyHomeOwner', ''),
                sync_enrollments: _.get(data, 'syncEnrollments', ''),
                enable_bulk_event_dispatch: _.get(data, 'enableBulkEvent', ''),
                allowed_sites: _.get(data, 'allowedSites', []),
                unsupported_solar_micros: _.get(data, 'unsupporedSolarMicros', []),
                min_site_stage: _.get(data, 'minSiteStage', []),
                min_eSW_Battery: _.get(data, 'minEswBattery', ''),
                min_eSW_ExportLimit: _.get(data, 'minEswExportLimit', ''),
                min_eSW_PV: _.get(data, 'minEswPv', ''),
                allowed_zip: _.get(data, 'allowedZipCodes', []),
                control_type: _.get(data, 'controlType', []),
                functions: _.get(data, 'functions', []),
                evse_control_type: _.get(data, 'evseControlType', ''),
                csip_enabled: _.get(data, 'csipEnabled', ''),
                csip_envoy_enabled: _.get(data, 'csipEnvoyEnabled', ''),
                csip_in_band_reg_enabled: _.get(data, 'csipInBandRegEnabled', ''),
                csip_direct_client: _.get(data, 'csipDirectClient', ''),
                csip_profile: _.get(data, 'profileList', []),
                csip_der_capability_fields: _.get(data, 'capabilityList', []),
                csip_der_settings_fields: _.get(data, 'settingsList', []),
                csip_allowed_controls: _.get(data, 'controlList', []),
                csip_mup_fields: _.get(data, 'telemetryList', []),
                csip_der_status_fields: _.get(data, 'statusList', []),
                system_access_list: _.get(data, 'systemAccessList', ''),
                event_feature_config: {
                  DEFAULT: {
                    event_cancellation_allowed_for_upcoming_events: _.get(data, 'cancelEventDefault', ''),
                    event_ending_allowed_for_ongoing_event: _.get(data, 'stopEventDefault', ''),
                    event_opt_in_opt_out_capability: _.get(data, 'eventOptDefault', ''),
                    target_soc_override: _.get(data, 'targetSocOverrideDefault', ''),
                    scheduled_power_override: _.get(data, 'scheduledPowerOverrideDefault', ''),
                    storm_guard_override: _.get(data, 'stormGuardOverrideDefault', '')
                  },
                  ...(isAutonomous
                    ? {
                      AUTONOMOUS: {
                        event_cancellation_allowed_for_upcoming_events: _.get(data, 'cancelEventRecurring', ''),
                        event_ending_allowed_for_ongoing_event: _.get(data, 'stopEventRecurring', ''),
                        event_opt_in_opt_out_capability: _.get(data, 'eventOptRecurring', ''),
                        target_soc_override: _.get(data, 'targetSocOverrideRecurring', ''),
                        scheduled_power_override: _.get(data, 'scheduledPowerOverrideRecurring', ''),
                        storm_guard_override: _.get(data, 'stormGuardOverrideRecurring', '')
                      }
                    }
                    : {})
                }
              }
              if (_.get(data, 'maxEventDurationDefault') && _.get(data, 'maxEventDurationDefault') !== '') {
                details.feature_flags.event_feature_config.DEFAULT.max_event_duration = _.get(data, 'maxEventDurationDefault', '') * 1000
              }
              if (_.get(data, 'minEventDurationDefault') && _.get(data, 'minEventDurationDefault') !== '') {
                details.feature_flags.event_feature_config.DEFAULT.min_event_duration = _.get(data, 'minEventDurationDefault', '') * 1000
              }
              if (isAutonomous && _.get(data, 'maxEventDurationRecurring') && _.get(data, 'maxEventDurationRecurring') !== '') {
                details.feature_flags.event_feature_config.AUTONOMOUS.max_event_duration = _.get(data, 'maxEventDurationRecurring', '') * 1000
              }
              if (isAutonomous && _.get(data, 'minEventDurationRecurring') && _.get(data, 'minEventDurationRecurring') !== '') {
                details.feature_flags.event_feature_config.AUTONOMOUS.min_event_duration = _.get(data, 'minEventDurationRecurring', '') * 1000
              }

              if (flagInProgram('pcu_polling_interval')) { details.feature_flags.pcu_polling_interval = _.get(data, 'pcuPollingInterval', '') }
              if (flagInProgram('pcu_bin_width')) { details.feature_flags.pcu_bin_width = _.get(data, 'pcuBinWidth', '') }
              if (flagInProgram('rgm_bin_width')) { details.feature_flags.rgm_bin_width = _.get(data, 'rgmBinWidth', '') }
              if (flagInProgram('rgm_polling_interval')) { details.feature_flags.rgm_polling_interval = _.get(data, 'rgmPollingInterval', '') }
              if (flagInProgram('reporting_interval_period')) { details.feature_flags.reporting_interval_period = _.get(data, 'reportingIntervalPeriod', '') }

              const batteryLockConfigValue = _.get(data, 'batteryLockConfig', '')
              if (batteryLockConfigValue && batteryLockConfigValue > 0) {
                details.battery_lock_config = {
                  "DISPATCH": {
                    "option" : "HOURS",
                    "hours_duration" : batteryLockConfigValue,
                    "lock_date_intervals" : null
                  }
                }
              }
              payload = _.cloneDeep(details)
              payload.account_id = _.get(data, 'account', '')
              setLoading(true)
              setPayload(payload)
            }
            if (!props.isSuperAdmin && props.isAdmin) {
              details.feature_flags = {
                event_types: _.get(data, 'eventTypes', []),
                event_subtypes: _.get(data, 'eventSubTypes', []),
                event_feature_config: {
                  DEFAULT: {
                    event_cancellation_allowed_for_upcoming_events: _.get(
                      data,
                      'cancelEventDefault',
                      ''
                    ),
                    event_ending_allowed_for_ongoing_event: _.get(
                      data,
                      'stopEventDefault',
                      ''
                    ),
                    event_opt_in_opt_out_capability: _.get(
                      data,
                      'eventOptDefault',
                      ''
                    ),
                  },
                },
              }
              payload = _.cloneDeep(details)
              payload.account_id = _.get(data, 'account', '')
              setLoading(true)
              setPayload(payload)
            }
            programService.updateProgram(props.accountId, props.programId, details)
              .then((response) => {
                setLoading(false)
                navToPrograms(true, response)
                props.getProgramById({
                  accountId: props.accountId,
                  programId: props.programId
                })
              })
              .catch((error) => {
                errorCb(error)
                props.getProgramById({
                  accountId: props.accountId,
                  programId: props.programId
                })
              })
          } else {
            details.feature_flags = {
              event_types: _.get(data, 'eventTypes', []),
              event_subtypes: _.get(data, 'eventSubTypes', []),
              event_feature_config: {
                DEFAULT: {
                  event_cancellation_allowed_for_upcoming_events: _.get(
                    data,
                    'cancelEventDefault',
                    ''
                  ),
                  event_ending_allowed_for_ongoing_event: _.get(
                    data,
                    'stopEventDefault',
                    ''
                  ),
                  event_opt_in_opt_out_capability: _.get(
                    data,
                    'eventOptDefault',
                    ''
                  ),
                },
              }
            }
            if (props.isSuperAdmin) {
              details.feature_flags.event_ending_allowed_for_ongoing_event = _.get(data, 'stopEventProgram', '')
              details.feature_flags.event_cancellation_allowed_for_upcoming_events = _.get(data, 'cancelEventProgram', '')
              details.feature_flags.event_opt_in_opt_out_capability = _.get(data, 'eventOptProgram', '')
              details.feature_flags.event_feature_config.DEFAULT.target_soc_override = _.get(data, 'targetSocOverrideDefault', '')
              details.feature_flags.event_feature_config.DEFAULT.scheduled_power_override = _.get(data, 'scheduledPowerOverrideDefault', '')
              details.feature_flags.functions = _.get(data, 'functions', '').split('')
            }
            payload = _.cloneDeep(details)
            payload.account_id = _.get(data, 'account', '')
            setLoading(true)
            setPayload(payload)
            programService.createProgram(props.accountId, details)
              .then(() => {
                setLoading(false)
                navToPrograms()
              })
              .catch((error) => errorCb(error))
          }
        }}
        render={({ values, handleChange, setFieldValue, errors, touched, dirty, isValid }) => {
          let submitButtonText = 'SUBMIT'
          if (props.isAdmin && !isEdit && accountDetails && accountDetails.account_feature_flags && accountDetails.account_feature_flags.auto_approve_programs) {
            submitButtonText = 'CREATE PROGRAM'
          }
          if (props.isSuperAdmin && !isEdit) {
            let account = allAccounts.find(acc => acc.id === _.get(values, 'account', ''))
            if (account && account.account_feature_flags && account.account_feature_flags.auto_approve_programs) {
              submitButtonText = 'CREATE PROGRAM'
            }
          }
          return (
            <Form>
              {isEdit && props.isSuperAdmin && <Box className={classes.formHeadingWrapper}>Program Highlights</Box>}
              <Box className={classes.formWrapper}>
                {form.slice(0, 2).map((container, index) => (
                  <Box className={classes.formContainer}>
                    {container.map(obj => (
                      <Box className={classes.fieldWrapper}>
                        {
                          obj.type === "select"
                            ? (
                              <TextField
                                select
                                id={obj.id}
                                name={obj.name}
                                label={obj.label}
                                className={classes.field}
                                InputProps={{
                                  classes: { root: classes.input, underline: classes.underline }
                                }}
                                SelectProps={{
                                  MenuProps: {
                                    classes: { paper: classes.paper },
                                    anchorOrigin: {
                                      vertical: "bottom",
                                      horizontal: "left"
                                    },
                                    getContentAnchorEl: null
                                  }
                                }}
                                value={values[obj.id]}
                                onChange={(e) => {
                                  if (obj.name === 'location') {
                                    setFieldValue('utilityName', '')
                                  }
                                  if (obj.name === 'country') {
                                    setSelectedCountry(e.target.value)
                                    setFieldValue('utilityName', '')
                                    getAllStates(e.target.value, setFieldValue)
                                  }
                                  setFieldValue(obj.name, e.target.value)
                                }}
                                disabled={(obj.id === 'account' || obj.id === 'utilityName' || obj.id === 'country' || obj.id === 'location') && isEdit ? true : obj.id === 'utilityName' ? !values['location'] : obj.id === 'location' && !values.country ? true : false}
                              >
                                {obj.name === 'utilityName' ?
                                  getUtilitesOptions(obj, values)
                                  : obj.options.map(option => {
                                    return <MenuItem value={option.value} label={option.label}>{option.label}</MenuItem>
                                  })}
                              </TextField>
                            )
                            : obj.type === 'date'
                              ? <Field
                                component={FormikDatePicker}
                                name='duration'
                                data={obj}
                              />
                              : (
                                <TextField
                                  id={obj.id}
                                  name={obj.name}
                                  label={obj.id === 'incentiveValue' ? renderLabel(values) : obj.label}
                                  className={classes.field}
                                  InputProps={{
                                    classes: { root: classes.input, underline: classes.underline },
                                    endAdornment: renderIcon(errors, touched, obj.id),
                                    type: obj.type === 'number' ? 'number' : 'text'
                                  }}
                                  onInput={(e) => {
                                    if (obj.id === 'maxEnrollment') {
                                      e.target.value = e.target.value !== '' ? parseInt(e.target.value) === 0 ? '' : Math.max(0, parseInt(e.target.value)).toString().replace(/[^0-9]*/g, '').slice(0, 9) : e.target.value
                                    } else if (obj.id !== 'enrollmentWebLink') {
                                      e.target.value = e.target.value ? (e.target.value).slice(0, 30) : e.target.value
                                    }
                                  }}
                                  InputLabelProps={{ classes: { root: classes.input, shrink: classes.shrink } }}
                                  value={obj.id === 'adminName' ? renderUniqueName(values) : values[obj.id]}
                                  onChange={(e) => {
                                    setFieldValue(obj.name, e.target.value)
                                  }}
                                  onBlur={(e) => setFieldValue(obj.name, e.target.value.trim())}
                                  disabled={obj.id === 'adminName' ? true : false}
                                />
                              )
                        }
                        <Typography className={classes.errorMessage}><ErrorMessage name={obj.name} /></Typography>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
              {((isEdit && props.isSuperAdmin) || (isEdit && props.isAdmin) || !isEdit) &&
                <>
                  <Box className={classes.formHeadingWrapper}>Program Specific Configurations</Box>
                  <Box className={classes.formWrapper}>
                    {form.slice(2, 4).map((container, index) => (
                      <Box className={classes.formContainer}>
                        <Box className={classes.featureFormWrapper}>
                          {container.map(obj => (
                            isEdit ? getForm(obj, values, setFieldValue, errors) : featureInCreation.includes(obj.id) && getForm(obj, values, setFieldValue, errors)
                          ))}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </>
              }
              <Box className={classes.boxWrapper}>
                <Box className={classes.sectionWrapper}>
                  {(isEdit && props.isSuperAdmin) &&
                    <Box className={`${classes.fieldWrapper} ${classes.labelWrapper}`}>
                      <Box className={classes.formHeadingWrapper} width='95%'>OpenADR Configurations</Box>
                        <Box className={classes.formWrapper} >
                          {form.slice(4, 5).map((container, index) => (
                            <Box className={`${classes.fieldWrapper} ${classes.multiFieldValues}`}>
                              <Box className={classes.featureFormWrapper}>
                                {container.map(obj => (
                                  isEdit && getForm(obj, values, setFieldValue, errors)
                                ))}
                              </Box>
                            </Box>
                          ))}
                      </Box>
                    </Box>
                  }
                </Box>
                <Box className={classes.csipSectionWrapper}>
                  {(isEdit && props.isSuperAdmin && csipConfigDetails) && 
                    <Box className={`${classes.fieldWrapper} ${classes.labelWrapper}`}>
                      <Box className={classes.formHeadingWrapper} width='95%'>CSIP Configuration</Box>
                        <Box className={classes.formContentWrapper} >
                          {getSwitchOption(csipConfiguration.CSIP_ENABLED, values, setFieldValue)}
                          {Object.entries(csipConfigDetails).map(item => {
                            // Skip country-related checkboxes as they are profile-level settings
                            if (item[0].toLowerCase().includes('country') || item[0].toLowerCase().includes('allowedcountries')) {
                              return null
                            }
                            return (
                              <Box className={`${classes.fieldWrapper} ${classes.multiFieldValues}`}>
                                <Box className={classes.featureFormWrapper}>
                                  {item[0] === PROFILE_LIST ? getdropDownList(item, values, setFieldValue) : item[0] !== 'id' ? getCheckBoxList(item, values, setFieldValue) : ''}
                                </Box>
                              </Box>
                            )
                          })}
                          {getSwitchOption(csipConfiguration.CSIP_ENVOY_ENABLED, values, setFieldValue)}
                          {getSwitchOption(csipConfiguration.CSIP_IN_BANDREG_ENABLED, values, setFieldValue)}
                          {getSwitchOption(csipConfiguration.CSIP_DIRECT_CLIENT, values, setFieldValue)}
                      </Box>
                    </Box>
                  }
                </Box>
              </Box>
              <hr className={classes.hr} />
              <Box className={classes.buttonWrapper}>
                <AppButton text='BACK' onClick={handleBack} fill={false} className={classes.button} />
                <AppButton text={submitButtonText} className={`${classes.button} ${dirty ? isValid && helperText === '' ? '' : classes.disable : classes.disable} `} type="submit" />
              </Box>
            </Form>
          )

        }}
      />
    )
  }

  const renderCreateProgramContent = () => {
    return (
      <Box>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <>
            {(isEdit && props.isSuperAdmin && _.get(props.programDetails, 'feature_flags.program_standardization', false)) &&
              <Box className={classes.toggleWrapper}>
                <Toggle
                  list={getProgramSettingsToggleOptions()}
                  selected={selectedToggle}
                  onChange={handleToggleChange}
                />
              </Box>
            }
            {(selectedToggle === programSettingsLabel.ENROLLMENT_CONFIGURATION) && renderEnrollmentConfiguration()}
            {(selectedToggle === programSettingsLabel.DASHBOARD_WIDGETS) && <DashboardWidgets setOpen={setOpen} setMessage={setMessage} setMessageType={setMessageType} errorCb={errorCb} setLoading={setLoading} {...props} />}
            {(selectedToggle === programSettingsLabel.PROGRAM_DETAILS) && renderProgramDetails()}
            {(selectedToggle === programSettingsLabel.PROGRAM_INFORMATION) && renderProgramInformation()}
          </>
        </MuiPickersUtilsProvider>
      </Box >
    )
  }

  return (
    <React.Fragment>
      {props.notFound ? <Error404 /> :
        <>
          <Breadcrumb value={renderNavValue()} />
          <Typography className={`${classes.title} ${classes.titleWrapper}`}>{isEdit ? 'Edit Program' : 'Create a New Program'}</Typography>
          <Cards className={classes.createWrapper} children={renderCreateProgramContent()} />
          <Loader loading={loading || accountLoading} />
          <DisplayMessage open={openToastMessage} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
        </>
      }
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getProgramById: (payload) => dispatch(getProgramById(payload)),
})

const mapStateToProps = ({ programs, auth }) => {
  const { stateList, programDetails, programId, notFound } = programs
  const { isSuperAdmin, isAdmin, accountId, currentUser } = auth
  return { stateList, isSuperAdmin, isAdmin, accountId, programDetails, programId, currentUser, notFound }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatePrograms)